// ******************************************************
// ******************************************************
// ******************************************************
// *****    Definition of the Images.
// *****    This code is generated. Do not edit manaully.
// ******************************************************
// ******************************************************
// ******************************************************
import { tbImage } from "../../engine/tbImage";
import * as textures from "./TextureDefinitions";
export var ICE_BLOCK_10X1_D1;
export var ICE_BLOCK_10X2_D1;
export var ICE_BLOCK_1X1_D1;
export var ICE_BLOCK_2X1_D1;
export var ICE_BLOCK_2X2_D1;
export var ICE_BLOCK_4X1_D1;
export var ICE_BLOCK_4X2_D1;
export var ICE_BLOCK_4X4_D1;
export var ICE_BLOCK_4X4_HOLLOW_D1;
export var ICE_BLOCK_8X1_D1;
export var ICE_BLOCK_8X2_D1;
export var ICE_CIRCLE_2X2_D1;
export var ICE_CIRCLE_4X4_D1;
export var ICE_TRIANGLE_4X4_D1;
export var ICE_TRIANGLE_4X4_D1_2;
export var ICE_TRIANGLE_4X4_HOLLOW_D1_2;
export var STONE_BLOCK_10X1_D1;
export var STONE_BLOCK_10X2_D1;
export var STONE_BLOCK_1X1_D1;
export var STONE_BLOCK_2X1_D1;
export var STONE_BLOCK_2X2_D1;
export var STONE_BLOCK_2X8_D1;
export var STONE_BLOCK_4X1_D1;
export var STONE_BLOCK_4X2_D1;
export var STONE_BLOCK_4X4_D1;
export var STONE_BLOCK_4X4_HOLLOW_D1;
export var STONE_BLOCK_8X1_D1;
export var STONE_BLOCK_8X2_D1;
export var STONE_CIRCLE_2X2_D1;
export var STONE_CIRCLE_4X4_D1;
export var STONE_TRIANGLE_4X4_D1;
export var STONE_TRIANGLE_4X4_D1_2;
export var STONE_TRIANGLE_4X4_HOLLOW_D1_2;
export var s_aiming_dot;
export var s_aiming_dot_mighty;
export var s_balloon_blue;
export var s_balloon_red;
export var s_balloon_yellow;
export var s_cage;
export var s_rope_big;
export var s_rope_small;
export var tnt_box;
export var WOOD_BLOCK_10X1_D1;
export var WOOD_BLOCK_10X2_D1;
export var WOOD_BLOCK_1X1_D1;
export var WOOD_BLOCK_2X1_D1;
export var WOOD_BLOCK_2X2_D1;
export var WOOD_BLOCK_4X1_D1;
export var WOOD_BLOCK_4X2_D1;
export var WOOD_BLOCK_4X4_D1;
export var WOOD_BLOCK_4X4_HOLLOW_D1;
export var WOOD_BLOCK_8X1_D1;
export var WOOD_BLOCK_8X2_D1;
export var WOOD_CIRCLE_2X2_D1;
export var WOOD_CIRCLE_4X4_D1;
export var WOOD_TRIANGLE_4X4_D1;
export var WOOD_TRIANGLE_4X4_D1_2;
export var WOOD_TRIANGLE_4X4_HOLLOW_D1_2;
export var s_button_notification;
export var s_chuck_speed;
export var s_hat_blue;
export var s_hat_pink;
export var s_pig_body;
export var s_pig_body_stroke;
export var s_pig_brow;
export var s_pig_damage_eye1;
export var s_pig_damage_eye2;
export var s_pig_damage_snout;
export var s_pig_default;
export var s_pig_default2;
export var s_pig_ears;
export var s_pig_eye;
export var s_pig_eye_closed;
export var s_pig_happy_big;
export var s_pig_nose;
export var s_pig_plaster;
export var s_pig_pupil;
export var s_pig_scared;
export var s_pig_tiny_smile;
export var s_pig_wistle;
export var s_s_blue_angry;
export var s_s_blue_body;
export var s_s_blue_body_stroke;
export var s_s_blue_default;
export var s_s_blue_eye;
export var s_s_blue_eye_overlay1;
export var s_s_blue_eye_overlay2;
export var s_s_blue_happy_big;
export var s_s_blue_head_feathers;
export var s_s_blue_pupil;
export var s_s_blue_sad;
export var s_s_blue_tail;
export var s_s_bomb_angry;
export var s_s_bomb_angry_big;
export var s_s_bomb_body;
export var s_s_bomb_body_stroke;
export var s_s_bomb_brow;
export var s_s_bomb_default;
export var s_s_bomb_effect;
export var s_s_bomb_eye;
export var s_s_bomb_eye2;
export var s_s_bomb_glow;
export var s_s_bomb_happy_big;
export var s_s_bomb_head_feather;
export var s_s_bomb_pupil;
export var s_s_bomb_sad;
export var s_s_bomb_squint;
export var s_s_chuck_angry;
export var s_s_chuck_angry_big;
export var s_s_chuck_body;
export var s_s_chuck_body_stroke;
export var s_s_chuck_brow;
export var s_s_chuck_default;
export var s_s_chuck_eye;
export var s_s_chuck_happy_big;
export var s_s_chuck_head_feather;
export var s_s_chuck_pupil;
export var s_s_chuck_pupil_copy1;
export var s_s_chuck_tail;
export var s_s_matilda_angry_big;
export var s_s_matilda_blush;
export var s_s_matilda_body;
export var s_s_matilda_body_stroke;
export var s_s_matilda_brow;
export var s_s_matilda_default;
export var s_s_matilda_eye;
export var s_s_matilda_eye_overlay1;
export var s_s_matilda_happy_big;
export var s_s_matilda_head_feather;
export var s_s_matilda_lash;
export var s_s_matilda_open_big;
export var s_s_matilda_pupil;
export var s_s_matilda_tail;
export var s_s_red_angry;
export var s_s_red_angry_big;
export var s_s_red_body;
export var s_s_red_body_stroke;
export var s_s_red_brow;
export var s_s_red_default;
export var s_s_red_eye;
export var s_s_red_head_feathers;
export var s_s_red_pupil;
export var s_s_red_scream;
export var s_s_red_tail;
export var s_s_terence_body;
export var s_s_terence_body_stroke;
export var s_s_terence_brow;
export var s_s_terence_default;
export var s_s_terence_eye;
export var s_s_terence_head_feathers;
export var s_s_terence_pupil;
export var s_s_terence_tail;
export var s_s_terence_wrinkle;
export var s_yell_circle;
export var s_yell_droplet;
export var s_yell_half_circle;
export var s_yell_lightning;
export var Custom_update_03;
export var Custom_share_01;
export var Custom_share_02;
export var Custom_update_01;
export var Custom_update_02;
export var gamebot_match_notification_01;
export var Feather_01;
export var sflag_red;
export var s_anim_beam_green;
export var s_anim_elipse2_green;
export var s_anim_sparkle;
export var s_anim_sparkle_green;
export var s_anim_spatter_green;
export var s_anim_stretchedlines_green;
export var s_blackpixel;
export var s_blue_angry;
export var s_blue_angry_big;
export var s_blue_body;
export var s_blue_body_stroke;
export var s_blue_default;
export var s_blue_eye;
export var s_blue_eyes_closed;
export var s_blue_eye_overlay1;
export var s_blue_eye_overlay2;
export var s_blue_happy;
export var s_blue_happy_big;
export var s_blue_head_feathers;
export var s_blue_open;
export var s_blue_open_big;
export var s_blue_out;
export var s_blue_pupil;
export var s_blue_sad;
export var s_blue_scream;
export var s_blue_scream1;
export var s_blue_smile;
export var s_blue_smirk;
export var s_blue_squint;
export var s_blue_tail;
export var s_blue_tail1;
export var s_bomb_angry;
export var s_bomb_angry_big;
export var s_bomb_angry_big1;
export var s_bomb_body;
export var s_bomb_body_stroke;
export var s_bomb_brow;
export var s_bomb_default;
export var s_bomb_eye;
export var s_bomb_eye2;
export var s_bomb_happy;
export var s_bomb_happy_big;
export var s_bomb_head_feather;
export var s_bomb_open;
export var s_bomb_open_big;
export var s_bomb_out;
export var s_bomb_pupil;
export var s_bomb_sad;
export var s_bomb_scream;
export var s_bomb_smile;
export var s_bomb_squint;
export var s_buttonbg_anim;
export var s_buttonbg_part;
export var s_buttonbg_timer1;
export var s_buttonbg_timer2;
export var s_button_glow;
export var s_cam_lines;
export var s_chuck_angry;
export var s_chuck_angry_big;
export var s_chuck_body;
export var s_chuck_body_stroke;
export var s_chuck_brow;
export var s_chuck_default;
export var s_chuck_eye;
export var s_chuck_eye2;
export var s_chuck_happy;
export var s_chuck_happy_big;
export var s_chuck_head_feather;
export var s_chuck_open;
export var s_chuck_open_big;
export var s_chuck_out;
export var s_chuck_pupil;
export var s_chuck_sad;
export var s_chuck_scream;
export var s_chuck_smile;
export var s_chuck_smirk;
export var s_chuck_squint;
export var s_chuck_tail;
export var s_explosion_001;
export var s_explosion_002;
export var s_explosion_003;
export var s_explosion_004;
export var s_explosion_005;
export var s_explosion_006;
export var s_explosion_007;
export var s_explosion_008;
export var s_explosion_009;
export var s_explosion_010;
export var s_explosion_011;
export var s_explosion_012;
export var s_explosion_013;
export var s_explosion_014;
export var s_explosion_015;
export var s_explosion_016;
export var s_explosion_017;
export var s_explosion_018;
export var s_flag_blue;
export var s_flag_yellow;
export var s_floodlight;
export var s_hourglass;
export var s_impact;
export var s_impact_white;
export var s_island;
export var s_island_blur;
export var s_lamp_green;
export var s_lamp_orange;
export var s_lamp_red;
export var s_matilda_angry;
export var s_matilda_angry_big;
export var s_matilda_blush;
export var s_matilda_body;
export var s_matilda_body_stroke;
export var s_matilda_brow;
export var s_matilda_default;
export var s_matilda_eye;
export var s_matilda_eye_closed;
export var s_matilda_eye_overlay1;
export var s_matilda_happy;
export var s_matilda_happy_big;
export var s_matilda_head_feather;
export var s_matilda_lash;
export var s_matilda_open;
export var s_matilda_open_big;
export var s_matilda_out;
export var s_matilda_pupil;
export var s_matilda_sad;
export var s_matilda_scream;
export var s_matilda_smile;
export var s_matilda_smirk;
export var s_matilda_tail;
export var s_motion_trail_001;
export var s_motion_trail_002;
export var s_motion_trail_003;
export var s_motion_trail_004;
export var s_motion_trail_005;
export var s_motion_trail_006;
export var s_motion_trail_007;
export var s_red_angry;
export var s_red_angry_big;
export var s_red_body;
export var s_red_body_stroke;
export var s_red_brow;
export var s_red_default;
export var s_red_eye;
export var s_red_happy;
export var s_red_happy_big;
export var s_red_head_feathers;
export var s_red_open;
export var s_red_open_big;
export var s_red_out;
export var s_red_pupil;
export var s_red_sad;
export var s_red_scream;
export var s_red_smile;
export var s_red_smirk;
export var s_red_squint;
export var s_red_tail;
export var s_replay_text;
export var s_shadow_bird;
export var s_shieldedge;
export var s_shieldsparkle1;
export var s_shieldsparkle2;
export var s_shockwave;
export var s_smokePuff_001;
export var s_smokePuff_002;
export var s_smokePuff_003;
export var s_smokePuff_004;
export var s_smokePuff_005;
export var s_smokePuff_006;
export var s_smokePuff_007;
export var s_smokePuff_008;
export var s_smokePuff_009;
export var s_smokePuff_010;
export var s_smokePuff_011;
export var s_smoke_plume_001;
export var s_smoke_plume_002;
export var s_smoke_plume_003;
export var s_smoke_plume_004;
export var s_smoke_plume_005;
export var s_smoke_plume_006;
export var s_smoke_plume_007;
export var s_smoke_plume_008;
export var s_smoke_plume_009;
export var s_smoke_plume_010;
export var s_smoke_plume_011;
export var s_smoke_plume_012;
export var s_smoke_plume_013;
export var s_smoke_plume_014;
export var s_smoke_plume_015;
export var s_smoke_plume_016;
export var s_static_1;
export var s_static_2;
export var s_terence_body;
export var s_terence_body_stroke;
export var s_terence_brow;
export var s_terence_default;
export var s_terence_eye;
export var s_terence_eyes_closed;
export var s_terence_head_feathers;
export var s_terence_pupil;
export var s_terence_smile;
export var s_terence_tail;
export var s_terence_wrinkle;
export var s_trumpet;
export var s_ui_vignette2_small;
export var s_vignette_scanlines;
export var s_tgf_console_close;
export var s_tgf_console_pause;
export var s_tgf_console_play;
export var s_tgf_console_position;
export var s_tgf_console_restart;
export var s_tgf_console_step;
export var s_tgf_icon_exit;
export var s_tgf_icon_music_off;
export var s_tgf_icon_music_on;
export var s_tgf_icon_options;
export var s_tgf_icon_pause;
export var s_tgf_icon_play;
export var s_tgf_icon_quit;
export var s_tgf_icon_retry;
export var s_tgf_icon_retry_large;
export var s_tgf_icon_sound_off;
export var s_tgf_icon_sound_on;
export var s_tgf_icon_undo;
export var s_tgf_slider_back;
export var s_tgf_button;
export var s_tgf_flag_fr;
export var s_tgf_icon_play_large;
export var s_tgf_progressbar_fill;
export var s_tgf_throbber;
export var s_ui_progress_round_background;
export var s_ui_progress_round_foreground;
export var s_ui_star_empty;
export var s_tgf_flag_ar;
export var s_tgf_flag_br;
export var s_tgf_icon_difficulty_easy;
export var s_tgf_flag_unknown;
export var s_tgf_transparent;
export var s_tgf_flag_de;
export var s_tgf_flag_es;
export var s_tgf_flag_gb;
export var s_tgf_flag_jp;
export var s_tgf_flag_kr;
export var s_tgf_flag_nl;
export var s_tgf_flag_ru;
export var s_tgf_flag_tr;
export var s_tgf_flag_us;
export var s_tgf_frame;
export var s_tgf_icon_difficulty_hard;
export var s_tgf_icon_difficulty_medium;
export var s_tgf_notification_error;
export var s_tgf_notification_message;
export var s_tgf_notification_warning;
export var s_tgf_progressbar_back;
export var s_tgf_slider_slider;
export var s_tgf_tutorial_close;
export var s_tgf_tutorial_next;
export var s_tgf_tutorial_previous;
export var s_ui_background;
export var s_ui_star_filled;
export var s_replay_overlay;
export var s_bg;
export var s_bg_placeholder;
export var s_button_glow2;
export var s_cartoonSmoke;
export var s_confetti1_particle;
export var s_confetti2_particle;
export var s_confetti3_particle;
export var s_confetti4_particle;
export var s_dust;
export var s_explosion;
export var s_feather;
export var s_gatcha_bg;
export var s_ice1_particle;
export var s_ice2_particle;
export var s_ice3_particle;
export var s_pig;
export var s_pig_blue;
export var s_pig_red;
export var s_sparkle_particle;
export var s_stone1_particle;
export var s_stone2_particle;
export var s_stone3_particle;
export var s_wood1_particle;
export var s_wood2_particle;
export var s_wood3_particle;
export var coolgames_logo;
export var rovio_logo;
export var yt_splash_1366x768_alternative_2;
export var s_bg_plain_blue;
export var s_bg_plain_red;
export var s_icon_leaderboard_spine;
export var s_player_beams;
export var s_ui_vignette;
export var s_bar_container_blue;
export var s_bar_title_blue;
export var s_beta_label_lobby;
export var s_btn_blue;
export var s_btn_round_blue;
export var s_btn_round_media_medium;
export var s_buttonpowerbg;
export var s_buttonpower_blue_light;
export var s_buttonpower_grey;
export var s_button_glow3;
export var s_button_rectangle2_white;
export var s_button_rectangle_white;
export var s_card_blue;
export var s_daily_reward_blue_bg_terence;
export var s_daily_reward_selection_box;
export var s_icon_back_small;
export var s_icon_plus_small;
export var s_icon_settings;
export var s_icon_share;
export var s_portrait_empty;
export var s_powerup_freeze;
export var s_powerup_stone_nator;
export var s_expbar_empty;
export var s_badgebg;
export var s_bar_container_green;
export var s_bar_title_green;
export var s_btn_green;
export var s_btn_round_green_big;
export var s_btn_round_green_small;
export var s_buttonpower_green;
export var s_buttonpower_teal;
export var s_card_bomb;
export var s_howtoplay_1;
export var s_howtoplay_2;
export var s_howtoplay_4;
export var s_howtoplay_5;
export var s_pigscore_main;
export var s_powerup_pig_swap;
export var s_progress_bar_fill;
export var s_startRandom;
export var s_ui_pig_green_default_main;
export var s_ui_pig_green_scared_main;
export var s_bar_timebg;
export var s_bar_title_grey;
export var s_icon_close;
export var s_icon_list;
export var s_icon_play_small;
export var s_ui_pig_green_default;
export var s_ui_pig_green_scared;
export var s_bar_container_grey;
export var s_bar_container_yellow;
export var s_bar_title_yellow;
export var s_bird_terrence;
export var s_btn_red;
export var s_btn_red_medium;
export var s_btn_red_small;
export var s_btn_round_gold;
export var s_btn_round_grey_big;
export var s_btn_round_orange_big;
export var s_btn_round_orange_small;
export var s_buttonpower_effect;
export var s_buttonpower_glow;
export var s_buttonpower_red;
export var s_button_beam;
export var s_button_small;
export var s_card_mathilda;
export var s_card_red;
export var s_card_yellow;
export var s_daily_reward_panel;
export var s_daily_reward_paper_sheet;
export var s_daily_reward_paper_sheet_torn;
export var s_daily_reward_powerup_icon;
export var s_friend_invite_matilda;
export var s_gemcontainer;
export var s_howtoplay_3;
export var s_icon_back;
export var s_icon_fforward_small;
export var s_icon_forward_small;
export var s_icon_gem;
export var s_icon_leaderboard;
export var s_icon_movie;
export var s_icon_music;
export var s_icon_musicoff;
export var s_icon_play;
export var s_icon_plus;
export var s_icon_poke;
export var s_icon_powerup;
export var s_icon_sound;
export var s_icon_soundoff;
export var s_pigscore;
export var s_popup_add_homescreen_content;
export var s_popup_bottom;
export var s_popup_close;
export var s_popup_top;
export var s_portrait_fill;
export var s_powerup_shield;
export var s_powerup_tnt;
export var s_profile_placeholder;
export var s_rankbg;
export var s_rectangle_white;
export var s_startFriend;
export var s_terence_timer_lobby;
export var s_titlesign;
export var s_trophy;
export var s_versus_center;
export var s_win_banner;
export var s_win_scorebg;
export var s_icon_toggle_music_off;
export var s_icon_toggle_music_on;
export var s_icon_toggle_sfx_off;
export var s_icon_toggle_sfx_on;
export var s_platform_stone;
export var s_stones;
export var s_about;
export var s_bg_blurred_20;
export var s_blueside;
export var s_btn_arrow_blue;
export var s_btn_arrow_media;
export var s_btn_bigtext;
export var s_btn_big_restart;
export var s_btn_big_start;
export var s_btn_small_exit;
export var s_btn_small_options;
export var s_btn_small_pause;
export var s_btn_small_retry;
export var s_btn_small_undo;
export var s_btn_standard;
export var s_btn_toggle;
export var s_buttons_bigtext;
export var s_buttons_bigtext_play;
export var s_cloud;
export var s_fog;
export var s_fog_2;
export var s_icon_toggle_fxoff;
export var s_icon_toggle_fxon;
export var s_icon_toggle_musicoff;
export var s_icon_toggle_musicon;
export var s_level2_0;
export var s_level2_lock;
export var s_logo;
export var s_logo_tinglygames;
export var s_overlay_assignment;
export var s_platform_stone_end_l;
export var s_platform_stone_end_r;
export var s_popup_darkblue_rect;
export var s_scorebar_blue;
export var s_swapPig_selected;
export var s_ui_landscape;
export var s_ui_portrait;
export var f_01;
export var f_02;
export var f_03;
export var f_04;
export var f_05;
export var f_06;
export var f_07;
export var f_08;
export var f_09;
export var f_10;
export var f_11;
export var f_12;
export var f_13;
export var f_14;
export var f_15;
export var f_16;
export var f_17;
export var f_18;
export var f_19;
export var f_20;
export var f_21;
export var f_22;
export var f_23;
export var f_24;
export var f_25;
export var m_01;
export var m_02;
export var m_03;
export var m_04;
export var m_05;
export var m_06;
export var m_07;
export var m_08;
export var m_09;
export var m_10;
export var m_11;
export var m_12;
export var m_13;
export var m_14;
export var m_15;
export var m_16;
export var m_17;
export var m_18;
export var m_19;
export var m_20;
export var m_21;
export var m_22;
export var m_23;
export var m_24;
export var m_25;
export var s_mighty_scope_bottom;
export var s_bg_tower;
export var s_bg_tower_2;
export var s_big_platform;
export var s_btn_arrow_green;
export var s_btn_round_video;
export var s_buttonbg_mighty_scope_active;
export var s_floating_platform;
export var s_floating_platform2;
export var s_floating_platform3;
export var s_floating_stackable_platform;
export var s_grey_floating_stackable_platform;
export var s_overlay_options;
export var s_overlay_settings;
export var s_progressbar_fill_green;
export var s_rank_emblem_azure;
export var s_rank_emblem_diamond;
export var s_rank_emblem_elder_silver;
export var s_rank_emblem_emerald;
export var s_rank_emblem_silver;
export var s_slingshot_back_azure;
export var s_slingshot_back_diamond;
export var s_slingshot_back_elder_silver;
export var s_slingshot_back_emerald;
export var s_slingshot_back_silver;
export var s_slingshot_front_azure;
export var s_slingshot_front_diamond;
export var s_slingshot_front_elder_silver;
export var s_slingshot_front_emerald;
export var s_slingshot_front_silver;
export var s_small_platform;
export var s_tgf_buttonSelect;
export var blackAdFrame;
export var s_black_square;
export var s_fg_object;
export var s_fg_object_2;
export var s_leaves;
export var s_leaves_2;
export var s_slingshot_bascket;
export var s_static_ground;
export var transparent_4x4;
export var custom_update_06;
export var FB_MessengerMock;
export var s_background;
export var s_btn_orange;
export var s_buttonbg_mighty_scope;
export var s_buttonpower_disabled;
export var s_button_drop_icon_coin;
export var s_card_big;
export var s_indicator_noplace;
export var s_indicator_target;
export var s_level2_1;
export var s_level2_2;
export var s_level2_3;
export var s_mighty_scope_popup_image;
export var s_mighty_scope_sparkle;
export var s_mighty_scope_top;
export var s_overlay_worldmap_levelselect;
export var s_portrait_01;
export var s_portrait_02;
export var s_portrait_03;
export var s_portrait_04;
export var s_portrait_05;
export var s_portrait_06;
export var s_portrait_07;
export var s_powerupcount;
export var s_practice_match_floater;
export var s_profilepicture_default;
export var s_progressbar_bg;
export var s_progressbar_fill_white;
export var s_rank_emblem_amethyst;
export var s_rank_emblem_bronze;
export var s_rank_emblem_elder_gold;
export var s_rank_emblem_gold;
export var s_rank_emblem_wood;
export var s_redcross;
export var s_redside;
export var s_scorebar_pink;
export var s_screen_start;
export var s_sfx_star;
export var s_shield;
export var s_shield01;
export var s_slingshot_back;
export var s_slingshot_back_amethyst;
export var s_slingshot_back_bronze;
export var s_slingshot_back_elder_gold;
export var s_slingshot_back_gold;
export var s_slingshot_front;
export var s_slingshot_front_amethyst;
export var s_slingshot_front_bronze;
export var s_slingshot_front_elder_gold;
export var s_slingshot_front_gold;
export var s_slingshot_rubber;
export var s_star01_empty;
export var s_star01_fill;
export var s_star02_empty;
export var s_star02_fill;
export var s_star03_empty;
export var s_star03_fill;
export var s_s_matilda_egg;
export var s_trail_splash;
export var s_tutorial;
export var s_tutorialButton_exit;
export var s_tutorialButton_next;
export var s_tutorialButton_previous;
export var s_win_board2;
export var initializeImages = function () {
    ICE_BLOCK_10X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 100, "y": 10 });
    ICE_BLOCK_10X1_D1.addImage("ICE_BLOCK_10X1_D1.png");
    ICE_BLOCK_10X1_D1.addImage("ICE_BLOCK_10X1_D1_1.png");
    ICE_BLOCK_10X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 100, "y": 20 });
    ICE_BLOCK_10X2_D1.addImage("ICE_BLOCK_10X2_D1.png");
    ICE_BLOCK_10X2_D1.addImage("ICE_BLOCK_10X2_D1_1.png");
    ICE_BLOCK_1X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 10, "y": 10 });
    ICE_BLOCK_1X1_D1.addImage("ICE_BLOCK_1X1_D1.png");
    ICE_BLOCK_1X1_D1.addImage("ICE_BLOCK_1X1_D1_1.png");
    ICE_BLOCK_2X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 20, "y": 10 });
    ICE_BLOCK_2X1_D1.addImage("ICE_BLOCK_2X1_D1.png");
    ICE_BLOCK_2X1_D1.addImage("ICE_BLOCK_2X1_D1_1.png");
    ICE_BLOCK_2X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 20, "y": 20 });
    ICE_BLOCK_2X2_D1.addImage("ICE_BLOCK_2X2_D1.png");
    ICE_BLOCK_2X2_D1.addImage("ICE_BLOCK_2X2_D1_1.png");
    ICE_BLOCK_4X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 10 });
    ICE_BLOCK_4X1_D1.addImage("ICE_BLOCK_4X1_D1.png");
    ICE_BLOCK_4X1_D1.addImage("ICE_BLOCK_4X1_D1_1.png");
    ICE_BLOCK_4X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 20 });
    ICE_BLOCK_4X2_D1.addImage("ICE_BLOCK_4X2_D1.png");
    ICE_BLOCK_4X2_D1.addImage("ICE_BLOCK_4X2_D1_1.png");
    ICE_BLOCK_4X4_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    ICE_BLOCK_4X4_D1.addImage("ICE_BLOCK_4X4_D1.png");
    ICE_BLOCK_4X4_D1.addImage("ICE_BLOCK_4X4_D1_1.png");
    ICE_BLOCK_4X4_HOLLOW_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    ICE_BLOCK_4X4_HOLLOW_D1.addImage("ICE_BLOCK_4X4_HOLLOW_D1.png");
    ICE_BLOCK_4X4_HOLLOW_D1.addImage("ICE_BLOCK_4X4_HOLLOW_D1_1.png");
    ICE_BLOCK_8X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 80, "y": 10 });
    ICE_BLOCK_8X1_D1.addImage("ICE_BLOCK_8X1_D1.png");
    ICE_BLOCK_8X1_D1.addImage("ICE_BLOCK_8X1_D1_1.png");
    ICE_BLOCK_8X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 80, "y": 20 });
    ICE_BLOCK_8X2_D1.addImage("ICE_BLOCK_8X2_D1.png");
    ICE_BLOCK_8X2_D1.addImage("ICE_BLOCK_8X2_D1_1.png");
    ICE_CIRCLE_2X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 20, "y": 20 });
    ICE_CIRCLE_2X2_D1.addImage("ICE_CIRCLE_2X2_D1.png");
    ICE_CIRCLE_2X2_D1.addImage("ICE_CIRCLE_2X2_D1_1.png");
    ICE_CIRCLE_4X4_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    ICE_CIRCLE_4X4_D1.addImage("ICE_CIRCLE_4X4_D1.png");
    ICE_CIRCLE_4X4_D1.addImage("ICE_CIRCLE_4X4_D1_1.png");
    ICE_TRIANGLE_4X4_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    ICE_TRIANGLE_4X4_D1.addImage("ICE_TRIANGLE_4X4_D1.png");
    ICE_TRIANGLE_4X4_D1.addImage("ICE_TRIANGLE_4X4_D1_1.png");
    ICE_TRIANGLE_4X4_D1_2 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    ICE_TRIANGLE_4X4_D1_2.addImage("ICE_TRIANGLE_4X4_D1_2.png");
    ICE_TRIANGLE_4X4_D1_2.addImage("ICE_TRIANGLE_4X4_D1_2_1.png");
    ICE_TRIANGLE_4X4_HOLLOW_D1_2 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    ICE_TRIANGLE_4X4_HOLLOW_D1_2.addImage("ICE_TRIANGLE_4X4_HOLLOW_D1_2.png");
    ICE_TRIANGLE_4X4_HOLLOW_D1_2.addImage("ICE_TRIANGLE_4X4_HOLLOW_D1_2_1.png");
    STONE_BLOCK_10X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 100, "y": 10 });
    STONE_BLOCK_10X1_D1.addImage("STONE_BLOCK_10X1_D1.png");
    STONE_BLOCK_10X1_D1.addImage("STONE_BLOCK_10X1_D1_1.png");
    STONE_BLOCK_10X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 100, "y": 20 });
    STONE_BLOCK_10X2_D1.addImage("STONE_BLOCK_10X2_D1.png");
    STONE_BLOCK_10X2_D1.addImage("STONE_BLOCK_10X2_D1_1.png");
    STONE_BLOCK_1X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 10, "y": 10 });
    STONE_BLOCK_1X1_D1.addImage("STONE_BLOCK_1X1_D1.png");
    STONE_BLOCK_1X1_D1.addImage("STONE_BLOCK_1X1_D1_1.png");
    STONE_BLOCK_2X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 20, "y": 10 });
    STONE_BLOCK_2X1_D1.addImage("STONE_BLOCK_2X1_D1.png");
    STONE_BLOCK_2X1_D1.addImage("STONE_BLOCK_2X1_D1_1.png");
    STONE_BLOCK_2X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 20, "y": 20 });
    STONE_BLOCK_2X2_D1.addImage("STONE_BLOCK_2X2_D1.png");
    STONE_BLOCK_2X2_D1.addImage("STONE_BLOCK_2X2_D1_1.png");
    STONE_BLOCK_2X8_D1 = new tbImage(textures.blocks, 1, undefined, { "x": 0, "y": 0 });
    STONE_BLOCK_2X8_D1.addImage("STONE_BLOCK_2X8_D1.png");
    STONE_BLOCK_4X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 10 });
    STONE_BLOCK_4X1_D1.addImage("STONE_BLOCK_4X1_D1.png");
    STONE_BLOCK_4X1_D1.addImage("STONE_BLOCK_4X1_D1_1.png");
    STONE_BLOCK_4X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 20 });
    STONE_BLOCK_4X2_D1.addImage("STONE_BLOCK_4X2_D1.png");
    STONE_BLOCK_4X2_D1.addImage("STONE_BLOCK_4X2_D1_1.png");
    STONE_BLOCK_4X4_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    STONE_BLOCK_4X4_D1.addImage("STONE_BLOCK_4X4_D1.png");
    STONE_BLOCK_4X4_D1.addImage("STONE_BLOCK_4X4_D1_1.png");
    STONE_BLOCK_4X4_HOLLOW_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    STONE_BLOCK_4X4_HOLLOW_D1.addImage("STONE_BLOCK_4X4_HOLLOW_D1.png");
    STONE_BLOCK_4X4_HOLLOW_D1.addImage("STONE_BLOCK_4X4_HOLLOW_D1_1.png");
    STONE_BLOCK_8X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 80, "y": 10 });
    STONE_BLOCK_8X1_D1.addImage("STONE_BLOCK_8X1_D1.png");
    STONE_BLOCK_8X1_D1.addImage("STONE_BLOCK_8X1_D1_1.png");
    STONE_BLOCK_8X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 80, "y": 20 });
    STONE_BLOCK_8X2_D1.addImage("STONE_BLOCK_8X2_D1.png");
    STONE_BLOCK_8X2_D1.addImage("STONE_BLOCK_8X2_D1_1.png");
    STONE_CIRCLE_2X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 20, "y": 20 });
    STONE_CIRCLE_2X2_D1.addImage("STONE_CIRCLE_2X2_D1.png");
    STONE_CIRCLE_2X2_D1.addImage("STONE_CIRCLE_2X2_D1_1.png");
    STONE_CIRCLE_4X4_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    STONE_CIRCLE_4X4_D1.addImage("STONE_CIRCLE_4X4_D1.png");
    STONE_CIRCLE_4X4_D1.addImage("STONE_CIRCLE_4X4_D1_1.png");
    STONE_TRIANGLE_4X4_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    STONE_TRIANGLE_4X4_D1.addImage("STONE_TRIANGLE_4X4_D1.png");
    STONE_TRIANGLE_4X4_D1.addImage("STONE_TRIANGLE_4X4_D1_1.png");
    STONE_TRIANGLE_4X4_D1_2 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    STONE_TRIANGLE_4X4_D1_2.addImage("STONE_TRIANGLE_4X4_D1_2.png");
    STONE_TRIANGLE_4X4_D1_2.addImage("STONE_TRIANGLE_4X4_D1_2_1.png");
    STONE_TRIANGLE_4X4_HOLLOW_D1_2 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    STONE_TRIANGLE_4X4_HOLLOW_D1_2.addImage("STONE_TRIANGLE_4X4_HOLLOW_D1_2.png");
    STONE_TRIANGLE_4X4_HOLLOW_D1_2.addImage("STONE_TRIANGLE_4X4_HOLLOW_D1_2_1.png");
    s_aiming_dot = new tbImage(textures.blocks, 1, undefined, { "x": 11, "y": 11 });
    s_aiming_dot.addImage("s_aiming_dot.png");
    s_aiming_dot_mighty = new tbImage(textures.blocks, 1, undefined, { "x": 12, "y": 13 });
    s_aiming_dot_mighty.addImage("s_aiming_dot_mighty.png");
    s_balloon_blue = new tbImage(textures.blocks, 1, undefined, { "x": 28, "y": 38 });
    s_balloon_blue.addImage("s_balloon_blue.png");
    s_balloon_red = new tbImage(textures.blocks, 1, undefined, { "x": 28, "y": 38 });
    s_balloon_red.addImage("s_balloon_red.png");
    s_balloon_yellow = new tbImage(textures.blocks, 1, undefined, { "x": 28, "y": 38 });
    s_balloon_yellow.addImage("s_balloon_yellow.png");
    s_cage = new tbImage(textures.blocks, 1, undefined, { "x": 40, "y": 40 });
    s_cage.addImage("s_cage.png");
    s_rope_big = new tbImage(textures.blocks, 1, undefined, { "x": 10, "y": 55 });
    s_rope_big.addImage("s_rope_big.png");
    s_rope_small = new tbImage(textures.blocks, 1, undefined, { "x": 10, "y": 30 });
    s_rope_small.addImage("s_rope_small.png");
    tnt_box = new tbImage(textures.blocks, 1, undefined, { "x": 30, "y": 30 });
    tnt_box.addImage("tnt_box.png");
    WOOD_BLOCK_10X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 100, "y": 10 });
    WOOD_BLOCK_10X1_D1.addImage("WOOD_BLOCK_10X1_D1.png");
    WOOD_BLOCK_10X1_D1.addImage("WOOD_BLOCK_10X1_D1_1.png");
    WOOD_BLOCK_10X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 100, "y": 20 });
    WOOD_BLOCK_10X2_D1.addImage("WOOD_BLOCK_10X2_D1.png");
    WOOD_BLOCK_10X2_D1.addImage("WOOD_BLOCK_10X2_D1_1.png");
    WOOD_BLOCK_1X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 10, "y": 10 });
    WOOD_BLOCK_1X1_D1.addImage("WOOD_BLOCK_1X1_D1.png");
    WOOD_BLOCK_1X1_D1.addImage("WOOD_BLOCK_1X1_D1_1.png");
    WOOD_BLOCK_2X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 20, "y": 10 });
    WOOD_BLOCK_2X1_D1.addImage("WOOD_BLOCK_2X1_D1.png");
    WOOD_BLOCK_2X1_D1.addImage("WOOD_BLOCK_2X1_D1_1.png");
    WOOD_BLOCK_2X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 20, "y": 20 });
    WOOD_BLOCK_2X2_D1.addImage("WOOD_BLOCK_2X2_D1.png");
    WOOD_BLOCK_2X2_D1.addImage("WOOD_BLOCK_2X2_D1_1.png");
    WOOD_BLOCK_4X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 10 });
    WOOD_BLOCK_4X1_D1.addImage("WOOD_BLOCK_4X1_D1.png");
    WOOD_BLOCK_4X1_D1.addImage("WOOD_BLOCK_4X1_D1_1.png");
    WOOD_BLOCK_4X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 20 });
    WOOD_BLOCK_4X2_D1.addImage("WOOD_BLOCK_4X2_D1.png");
    WOOD_BLOCK_4X2_D1.addImage("WOOD_BLOCK_4X2_D1_1.png");
    WOOD_BLOCK_4X4_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    WOOD_BLOCK_4X4_D1.addImage("WOOD_BLOCK_4X4_D1.png");
    WOOD_BLOCK_4X4_D1.addImage("WOOD_BLOCK_4X4_D1_1.png");
    WOOD_BLOCK_4X4_HOLLOW_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    WOOD_BLOCK_4X4_HOLLOW_D1.addImage("WOOD_BLOCK_4X4_HOLLOW_D1.png");
    WOOD_BLOCK_4X4_HOLLOW_D1.addImage("WOOD_BLOCK_4X4_HOLLOW_D1_1.png");
    WOOD_BLOCK_8X1_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 80, "y": 10 });
    WOOD_BLOCK_8X1_D1.addImage("WOOD_BLOCK_8X1_D1.png");
    WOOD_BLOCK_8X1_D1.addImage("WOOD_BLOCK_8X1_D1_1.png");
    WOOD_BLOCK_8X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 80, "y": 20 });
    WOOD_BLOCK_8X2_D1.addImage("WOOD_BLOCK_8X2_D1.png");
    WOOD_BLOCK_8X2_D1.addImage("WOOD_BLOCK_8X2_D1_1.png");
    WOOD_CIRCLE_2X2_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 20, "y": 20 });
    WOOD_CIRCLE_2X2_D1.addImage("WOOD_CIRCLE_2X2_D1.png");
    WOOD_CIRCLE_2X2_D1.addImage("WOOD_CIRCLE_2X2_D1_1.png");
    WOOD_CIRCLE_4X4_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    WOOD_CIRCLE_4X4_D1.addImage("WOOD_CIRCLE_4X4_D1.png");
    WOOD_CIRCLE_4X4_D1.addImage("WOOD_CIRCLE_4X4_D1_1.png");
    WOOD_TRIANGLE_4X4_D1 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    WOOD_TRIANGLE_4X4_D1.addImage("WOOD_TRIANGLE_4X4_D1.png");
    WOOD_TRIANGLE_4X4_D1.addImage("WOOD_TRIANGLE_4X4_D1_1.png");
    WOOD_TRIANGLE_4X4_D1_2 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    WOOD_TRIANGLE_4X4_D1_2.addImage("WOOD_TRIANGLE_4X4_D1_2.png");
    WOOD_TRIANGLE_4X4_D1_2.addImage("WOOD_TRIANGLE_4X4_D1_2_1.png");
    WOOD_TRIANGLE_4X4_HOLLOW_D1_2 = new tbImage(textures.blocks, 2, undefined, { "x": 40, "y": 40 });
    WOOD_TRIANGLE_4X4_HOLLOW_D1_2.addImage("WOOD_TRIANGLE_4X4_HOLLOW_D1_2.png");
    WOOD_TRIANGLE_4X4_HOLLOW_D1_2.addImage("WOOD_TRIANGLE_4X4_HOLLOW_D1_2_1.png");
    s_button_notification = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_button_notification.addImage("s_button_notification.png");
    s_chuck_speed = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_speed.addImage("s_chuck_speed.png");
    s_hat_blue = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_hat_blue.addImage("s_hat_blue.png");
    s_hat_pink = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_hat_pink.addImage("s_hat_pink.png");
    s_pig_body = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_body.addImage("s_pig_body.png");
    s_pig_body_stroke = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_body_stroke.addImage("s_pig_body_stroke.png");
    s_pig_brow = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_brow.addImage("s_pig_brow.png");
    s_pig_damage_eye1 = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_damage_eye1.addImage("s_pig_damage_eye1.png");
    s_pig_damage_eye2 = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_damage_eye2.addImage("s_pig_damage_eye2.png");
    s_pig_damage_snout = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_damage_snout.addImage("s_pig_damage_snout.png");
    s_pig_default = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_default.addImage("s_pig_default.png");
    s_pig_default2 = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_default2.addImage("s_pig_default2.png");
    s_pig_ears = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_ears.addImage("s_pig_ears.png");
    s_pig_eye = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_eye.addImage("s_pig_eye.png");
    s_pig_eye_closed = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_eye_closed.addImage("s_pig_eye_closed.png");
    s_pig_happy_big = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_happy_big.addImage("s_pig_happy_big.png");
    s_pig_nose = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_nose.addImage("s_pig_nose.png");
    s_pig_plaster = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_plaster.addImage("s_pig_plaster.png");
    s_pig_pupil = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_pupil.addImage("s_pig_pupil.png");
    s_pig_scared = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_scared.addImage("s_pig_scared.png");
    s_pig_tiny_smile = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_tiny_smile.addImage("s_pig_tiny_smile.png");
    s_pig_wistle = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_pig_wistle.addImage("s_pig_wistle.png");
    s_s_blue_angry = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_angry.addImage("s_s_blue_angry.png");
    s_s_blue_body = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_body.addImage("s_s_blue_body.png");
    s_s_blue_body_stroke = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_body_stroke.addImage("s_s_blue_body_stroke.png");
    s_s_blue_default = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_default.addImage("s_s_blue_default.png");
    s_s_blue_eye = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_eye.addImage("s_s_blue_eye.png");
    s_s_blue_eye_overlay1 = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_eye_overlay1.addImage("s_s_blue_eye_overlay1.png");
    s_s_blue_eye_overlay2 = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_eye_overlay2.addImage("s_s_blue_eye_overlay2.png");
    s_s_blue_happy_big = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_happy_big.addImage("s_s_blue_happy_big.png");
    s_s_blue_head_feathers = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_head_feathers.addImage("s_s_blue_head_feathers.png");
    s_s_blue_pupil = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_pupil.addImage("s_s_blue_pupil.png");
    s_s_blue_sad = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_sad.addImage("s_s_blue_sad.png");
    s_s_blue_tail = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_blue_tail.addImage("s_s_blue_tail.png");
    s_s_bomb_angry = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_angry.addImage("s_s_bomb_angry.png");
    s_s_bomb_angry_big = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_angry_big.addImage("s_s_bomb_angry_big.png");
    s_s_bomb_body = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_body.addImage("s_s_bomb_body.png");
    s_s_bomb_body_stroke = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_body_stroke.addImage("s_s_bomb_body_stroke.png");
    s_s_bomb_brow = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_brow.addImage("s_s_bomb_brow.png");
    s_s_bomb_default = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_default.addImage("s_s_bomb_default.png");
    s_s_bomb_effect = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_effect.addImage("s_s_bomb_effect.png");
    s_s_bomb_eye = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_eye.addImage("s_s_bomb_eye.png");
    s_s_bomb_eye2 = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_eye2.addImage("s_s_bomb_eye2.png");
    s_s_bomb_glow = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_glow.addImage("s_s_bomb_glow.png");
    s_s_bomb_happy_big = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_happy_big.addImage("s_s_bomb_happy_big.png");
    s_s_bomb_head_feather = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_head_feather.addImage("s_s_bomb_head_feather.png");
    s_s_bomb_pupil = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_pupil.addImage("s_s_bomb_pupil.png");
    s_s_bomb_sad = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_sad.addImage("s_s_bomb_sad.png");
    s_s_bomb_squint = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_bomb_squint.addImage("s_s_bomb_squint.png");
    s_s_chuck_angry = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_angry.addImage("s_s_chuck_angry.png");
    s_s_chuck_angry_big = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_angry_big.addImage("s_s_chuck_angry_big.png");
    s_s_chuck_body = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_body.addImage("s_s_chuck_body.png");
    s_s_chuck_body_stroke = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_body_stroke.addImage("s_s_chuck_body_stroke.png");
    s_s_chuck_brow = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_brow.addImage("s_s_chuck_brow.png");
    s_s_chuck_default = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_default.addImage("s_s_chuck_default.png");
    s_s_chuck_eye = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_eye.addImage("s_s_chuck_eye.png");
    s_s_chuck_happy_big = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_happy_big.addImage("s_s_chuck_happy_big.png");
    s_s_chuck_head_feather = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_head_feather.addImage("s_s_chuck_head_feather.png");
    s_s_chuck_pupil = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_pupil.addImage("s_s_chuck_pupil.png");
    s_s_chuck_pupil_copy1 = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_pupil_copy1.addImage("s_s_chuck_pupil_copy1.png");
    s_s_chuck_tail = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_chuck_tail.addImage("s_s_chuck_tail.png");
    s_s_matilda_angry_big = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_angry_big.addImage("s_s_matilda_angry_big.png");
    s_s_matilda_blush = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_blush.addImage("s_s_matilda_blush.png");
    s_s_matilda_body = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_body.addImage("s_s_matilda_body.png");
    s_s_matilda_body_stroke = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_body_stroke.addImage("s_s_matilda_body_stroke.png");
    s_s_matilda_brow = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_brow.addImage("s_s_matilda_brow.png");
    s_s_matilda_default = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_default.addImage("s_s_matilda_default.png");
    s_s_matilda_eye = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_eye.addImage("s_s_matilda_eye.png");
    s_s_matilda_eye_overlay1 = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_eye_overlay1.addImage("s_s_matilda_eye_overlay1.png");
    s_s_matilda_happy_big = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_happy_big.addImage("s_s_matilda_happy_big.png");
    s_s_matilda_head_feather = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_head_feather.addImage("s_s_matilda_head_feather.png");
    s_s_matilda_lash = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_lash.addImage("s_s_matilda_lash.png");
    s_s_matilda_open_big = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_open_big.addImage("s_s_matilda_open_big.png");
    s_s_matilda_pupil = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_pupil.addImage("s_s_matilda_pupil.png");
    s_s_matilda_tail = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_matilda_tail.addImage("s_s_matilda_tail.png");
    s_s_red_angry = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_red_angry.addImage("s_s_red_angry.png");
    s_s_red_angry_big = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_red_angry_big.addImage("s_s_red_angry_big.png");
    s_s_red_body = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_red_body.addImage("s_s_red_body.png");
    s_s_red_body_stroke = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_red_body_stroke.addImage("s_s_red_body_stroke.png");
    s_s_red_brow = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_red_brow.addImage("s_s_red_brow.png");
    s_s_red_default = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_red_default.addImage("s_s_red_default.png");
    s_s_red_eye = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_red_eye.addImage("s_s_red_eye.png");
    s_s_red_head_feathers = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_red_head_feathers.addImage("s_s_red_head_feathers.png");
    s_s_red_pupil = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_red_pupil.addImage("s_s_red_pupil.png");
    s_s_red_scream = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_red_scream.addImage("s_s_red_scream.png");
    s_s_red_tail = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_red_tail.addImage("s_s_red_tail.png");
    s_s_terence_body = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_terence_body.addImage("s_s_terence_body.png");
    s_s_terence_body_stroke = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_terence_body_stroke.addImage("s_s_terence_body_stroke.png");
    s_s_terence_brow = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_terence_brow.addImage("s_s_terence_brow.png");
    s_s_terence_default = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_terence_default.addImage("s_s_terence_default.png");
    s_s_terence_eye = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_terence_eye.addImage("s_s_terence_eye.png");
    s_s_terence_head_feathers = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_terence_head_feathers.addImage("s_s_terence_head_feathers.png");
    s_s_terence_pupil = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_terence_pupil.addImage("s_s_terence_pupil.png");
    s_s_terence_tail = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_terence_tail.addImage("s_s_terence_tail.png");
    s_s_terence_wrinkle = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_s_terence_wrinkle.addImage("s_s_terence_wrinkle.png");
    s_yell_circle = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_yell_circle.addImage("s_yell_circle.png");
    s_yell_droplet = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_yell_droplet.addImage("s_yell_droplet.png");
    s_yell_half_circle = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_yell_half_circle.addImage("s_yell_half_circle.png");
    s_yell_lightning = new tbImage(textures.characterAnimations, 1, undefined, { "x": 0, "y": 0 });
    s_yell_lightning.addImage("s_yell_lightning.png");
    Custom_update_03 = new tbImage(textures.CustomUpdates_blue_2, 1, undefined, { "x": 0, "y": 0 });
    Custom_update_03.addImage("Custom_update_03.png");
    Custom_share_01 = new tbImage(textures.CustomUpdates_red_2, 1, undefined, { "x": 0, "y": 0 });
    Custom_share_01.addImage("Custom_share_01.png");
    Custom_share_02 = new tbImage(textures.CustomUpdates_red_2, 1, undefined, { "x": 0, "y": 0 });
    Custom_share_02.addImage("Custom_share_02.png");
    Custom_update_01 = new tbImage(textures.CustomUpdates_red_2, 1, undefined, { "x": 0, "y": 0 });
    Custom_update_01.addImage("Custom_update_01.png");
    Custom_update_02 = new tbImage(textures.CustomUpdates_red_2, 1, undefined, { "x": 0, "y": 0 });
    Custom_update_02.addImage("Custom_update_02.png");
    gamebot_match_notification_01 = new tbImage(textures.CustomUpdates_red_2, 1, undefined, { "x": 0, "y": 0 });
    gamebot_match_notification_01.addImage("gamebot_match_notification_01.png");
    Feather_01 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    Feather_01.addImage("Feather_01.png");
    sflag_red = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    sflag_red.addImage("sflag_red.png");
    s_anim_beam_green = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_anim_beam_green.addImage("s_anim_beam_green.png");
    s_anim_elipse2_green = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_anim_elipse2_green.addImage("s_anim_elipse2_green.png");
    s_anim_sparkle = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_anim_sparkle.addImage("s_anim_sparkle.png");
    s_anim_sparkle_green = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_anim_sparkle_green.addImage("s_anim_sparkle_green.png");
    s_anim_spatter_green = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_anim_spatter_green.addImage("s_anim_spatter_green.png");
    s_anim_stretchedlines_green = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_anim_stretchedlines_green.addImage("s_anim_stretchedlines_green.png");
    s_blackpixel = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blackpixel.addImage("s_blackpixel.png");
    s_blue_angry = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_angry.addImage("s_blue_angry.png");
    s_blue_angry_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_angry_big.addImage("s_blue_angry_big.png");
    s_blue_body = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_body.addImage("s_blue_body.png");
    s_blue_body_stroke = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_body_stroke.addImage("s_blue_body_stroke.png");
    s_blue_default = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_default.addImage("s_blue_default.png");
    s_blue_eye = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_eye.addImage("s_blue_eye.png");
    s_blue_eyes_closed = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_eyes_closed.addImage("s_blue_eyes_closed.png");
    s_blue_eye_overlay1 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_eye_overlay1.addImage("s_blue_eye_overlay1.png");
    s_blue_eye_overlay2 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_eye_overlay2.addImage("s_blue_eye_overlay2.png");
    s_blue_happy = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_happy.addImage("s_blue_happy.png");
    s_blue_happy_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_happy_big.addImage("s_blue_happy_big.png");
    s_blue_head_feathers = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_head_feathers.addImage("s_blue_head_feathers.png");
    s_blue_open = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_open.addImage("s_blue_open.png");
    s_blue_open_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_open_big.addImage("s_blue_open_big.png");
    s_blue_out = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_out.addImage("s_blue_out.png");
    s_blue_pupil = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_pupil.addImage("s_blue_pupil.png");
    s_blue_sad = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_sad.addImage("s_blue_sad.png");
    s_blue_scream = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_scream.addImage("s_blue_scream.png");
    s_blue_scream1 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_scream1.addImage("s_blue_scream1.png");
    s_blue_smile = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_smile.addImage("s_blue_smile.png");
    s_blue_smirk = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_smirk.addImage("s_blue_smirk.png");
    s_blue_squint = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_squint.addImage("s_blue_squint.png");
    s_blue_tail = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_tail.addImage("s_blue_tail.png");
    s_blue_tail1 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_blue_tail1.addImage("s_blue_tail1.png");
    s_bomb_angry = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_angry.addImage("s_bomb_angry.png");
    s_bomb_angry_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_angry_big.addImage("s_bomb_angry_big.png");
    s_bomb_angry_big1 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_angry_big1.addImage("s_bomb_angry_big1.png");
    s_bomb_body = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_body.addImage("s_bomb_body.png");
    s_bomb_body_stroke = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_body_stroke.addImage("s_bomb_body_stroke.png");
    s_bomb_brow = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_brow.addImage("s_bomb_brow.png");
    s_bomb_default = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_default.addImage("s_bomb_default.png");
    s_bomb_eye = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_eye.addImage("s_bomb_eye.png");
    s_bomb_eye2 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_eye2.addImage("s_bomb_eye2.png");
    s_bomb_happy = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_happy.addImage("s_bomb_happy.png");
    s_bomb_happy_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_happy_big.addImage("s_bomb_happy_big.png");
    s_bomb_head_feather = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_head_feather.addImage("s_bomb_head_feather.png");
    s_bomb_open = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_open.addImage("s_bomb_open.png");
    s_bomb_open_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_open_big.addImage("s_bomb_open_big.png");
    s_bomb_out = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_out.addImage("s_bomb_out.png");
    s_bomb_pupil = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_pupil.addImage("s_bomb_pupil.png");
    s_bomb_sad = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_sad.addImage("s_bomb_sad.png");
    s_bomb_scream = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_scream.addImage("s_bomb_scream.png");
    s_bomb_smile = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_smile.addImage("s_bomb_smile.png");
    s_bomb_squint = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_bomb_squint.addImage("s_bomb_squint.png");
    s_buttonbg_anim = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_buttonbg_anim.addImage("s_buttonbg_anim.png");
    s_buttonbg_part = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_buttonbg_part.addImage("s_buttonbg_part.png");
    s_buttonbg_timer1 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_buttonbg_timer1.addImage("s_buttonbg_timer1.png");
    s_buttonbg_timer2 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_buttonbg_timer2.addImage("s_buttonbg_timer2.png");
    s_button_glow = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_button_glow.addImage("s_button_glow.png");
    s_cam_lines = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_cam_lines.addImage("s_cam_lines.png");
    s_chuck_angry = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_angry.addImage("s_chuck_angry.png");
    s_chuck_angry_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_angry_big.addImage("s_chuck_angry_big.png");
    s_chuck_body = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_body.addImage("s_chuck_body.png");
    s_chuck_body_stroke = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_body_stroke.addImage("s_chuck_body_stroke.png");
    s_chuck_brow = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_brow.addImage("s_chuck_brow.png");
    s_chuck_default = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_default.addImage("s_chuck_default.png");
    s_chuck_eye = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_eye.addImage("s_chuck_eye.png");
    s_chuck_eye2 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_eye2.addImage("s_chuck_eye2.png");
    s_chuck_happy = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_happy.addImage("s_chuck_happy.png");
    s_chuck_happy_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_happy_big.addImage("s_chuck_happy_big.png");
    s_chuck_head_feather = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_head_feather.addImage("s_chuck_head_feather.png");
    s_chuck_open = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_open.addImage("s_chuck_open.png");
    s_chuck_open_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_open_big.addImage("s_chuck_open_big.png");
    s_chuck_out = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_out.addImage("s_chuck_out.png");
    s_chuck_pupil = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_pupil.addImage("s_chuck_pupil.png");
    s_chuck_sad = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_sad.addImage("s_chuck_sad.png");
    s_chuck_scream = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_scream.addImage("s_chuck_scream.png");
    s_chuck_smile = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_smile.addImage("s_chuck_smile.png");
    s_chuck_smirk = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_smirk.addImage("s_chuck_smirk.png");
    s_chuck_squint = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_squint.addImage("s_chuck_squint.png");
    s_chuck_tail = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_chuck_tail.addImage("s_chuck_tail.png");
    s_explosion_001 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_001.addImage("s_explosion_001.png");
    s_explosion_002 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_002.addImage("s_explosion_002.png");
    s_explosion_003 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_003.addImage("s_explosion_003.png");
    s_explosion_004 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_004.addImage("s_explosion_004.png");
    s_explosion_005 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_005.addImage("s_explosion_005.png");
    s_explosion_006 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_006.addImage("s_explosion_006.png");
    s_explosion_007 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_007.addImage("s_explosion_007.png");
    s_explosion_008 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_008.addImage("s_explosion_008.png");
    s_explosion_009 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_009.addImage("s_explosion_009.png");
    s_explosion_010 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_010.addImage("s_explosion_010.png");
    s_explosion_011 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_011.addImage("s_explosion_011.png");
    s_explosion_012 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_012.addImage("s_explosion_012.png");
    s_explosion_013 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_013.addImage("s_explosion_013.png");
    s_explosion_014 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_014.addImage("s_explosion_014.png");
    s_explosion_015 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_015.addImage("s_explosion_015.png");
    s_explosion_016 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_016.addImage("s_explosion_016.png");
    s_explosion_017 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_017.addImage("s_explosion_017.png");
    s_explosion_018 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_explosion_018.addImage("s_explosion_018.png");
    s_flag_blue = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_flag_blue.addImage("s_flag_blue.png");
    s_flag_yellow = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_flag_yellow.addImage("s_flag_yellow.png");
    s_floodlight = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_floodlight.addImage("s_floodlight.png");
    s_hourglass = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_hourglass.addImage("s_hourglass.png");
    s_impact = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_impact.addImage("s_impact.png");
    s_impact_white = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_impact_white.addImage("s_impact_white.png");
    s_island = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_island.addImage("s_island.png");
    s_island_blur = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_island_blur.addImage("s_island_blur.png");
    s_lamp_green = new tbImage(textures.endScreens, 1, undefined, { "x": 16, "y": 15 });
    s_lamp_green.addImage("s_lamp_green.png");
    s_lamp_orange = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_lamp_orange.addImage("s_lamp_orange.png");
    s_lamp_red = new tbImage(textures.endScreens, 1, undefined, { "x": 16, "y": 15 });
    s_lamp_red.addImage("s_lamp_red.png");
    s_matilda_angry = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_angry.addImage("s_matilda_angry.png");
    s_matilda_angry_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_angry_big.addImage("s_matilda_angry_big.png");
    s_matilda_blush = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_blush.addImage("s_matilda_blush.png");
    s_matilda_body = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_body.addImage("s_matilda_body.png");
    s_matilda_body_stroke = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_body_stroke.addImage("s_matilda_body_stroke.png");
    s_matilda_brow = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_brow.addImage("s_matilda_brow.png");
    s_matilda_default = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_default.addImage("s_matilda_default.png");
    s_matilda_eye = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_eye.addImage("s_matilda_eye.png");
    s_matilda_eye_closed = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_eye_closed.addImage("s_matilda_eye_closed.png");
    s_matilda_eye_overlay1 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_eye_overlay1.addImage("s_matilda_eye_overlay1.png");
    s_matilda_happy = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_happy.addImage("s_matilda_happy.png");
    s_matilda_happy_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_happy_big.addImage("s_matilda_happy_big.png");
    s_matilda_head_feather = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_head_feather.addImage("s_matilda_head_feather.png");
    s_matilda_lash = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_lash.addImage("s_matilda_lash.png");
    s_matilda_open = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_open.addImage("s_matilda_open.png");
    s_matilda_open_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_open_big.addImage("s_matilda_open_big.png");
    s_matilda_out = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_out.addImage("s_matilda_out.png");
    s_matilda_pupil = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_pupil.addImage("s_matilda_pupil.png");
    s_matilda_sad = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_sad.addImage("s_matilda_sad.png");
    s_matilda_scream = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_scream.addImage("s_matilda_scream.png");
    s_matilda_smile = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_smile.addImage("s_matilda_smile.png");
    s_matilda_smirk = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_smirk.addImage("s_matilda_smirk.png");
    s_matilda_tail = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_matilda_tail.addImage("s_matilda_tail.png");
    s_motion_trail_001 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_motion_trail_001.addImage("s_motion_trail_001.png");
    s_motion_trail_002 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_motion_trail_002.addImage("s_motion_trail_002.png");
    s_motion_trail_003 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_motion_trail_003.addImage("s_motion_trail_003.png");
    s_motion_trail_004 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_motion_trail_004.addImage("s_motion_trail_004.png");
    s_motion_trail_005 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_motion_trail_005.addImage("s_motion_trail_005.png");
    s_motion_trail_006 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_motion_trail_006.addImage("s_motion_trail_006.png");
    s_motion_trail_007 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_motion_trail_007.addImage("s_motion_trail_007.png");
    s_red_angry = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_angry.addImage("s_red_angry.png");
    s_red_angry_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_angry_big.addImage("s_red_angry_big.png");
    s_red_body = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_body.addImage("s_red_body.png");
    s_red_body_stroke = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_body_stroke.addImage("s_red_body_stroke.png");
    s_red_brow = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_brow.addImage("s_red_brow.png");
    s_red_default = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_default.addImage("s_red_default.png");
    s_red_eye = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_eye.addImage("s_red_eye.png");
    s_red_happy = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_happy.addImage("s_red_happy.png");
    s_red_happy_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_happy_big.addImage("s_red_happy_big.png");
    s_red_head_feathers = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_head_feathers.addImage("s_red_head_feathers.png");
    s_red_open = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_open.addImage("s_red_open.png");
    s_red_open_big = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_open_big.addImage("s_red_open_big.png");
    s_red_out = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_out.addImage("s_red_out.png");
    s_red_pupil = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_pupil.addImage("s_red_pupil.png");
    s_red_sad = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_sad.addImage("s_red_sad.png");
    s_red_scream = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_scream.addImage("s_red_scream.png");
    s_red_smile = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_smile.addImage("s_red_smile.png");
    s_red_smirk = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_smirk.addImage("s_red_smirk.png");
    s_red_squint = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_squint.addImage("s_red_squint.png");
    s_red_tail = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_red_tail.addImage("s_red_tail.png");
    s_replay_text = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_replay_text.addImage("s_replay_text.png");
    s_shadow_bird = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_shadow_bird.addImage("s_shadow_bird.png");
    s_shieldedge = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_shieldedge.addImage("s_shieldedge.png");
    s_shieldsparkle1 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_shieldsparkle1.addImage("s_shieldsparkle1.png");
    s_shieldsparkle2 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_shieldsparkle2.addImage("s_shieldsparkle2.png");
    s_shockwave = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_shockwave.addImage("s_shockwave.png");
    s_smokePuff_001 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smokePuff_001.addImage("s_smokePuff_001.png");
    s_smokePuff_002 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smokePuff_002.addImage("s_smokePuff_002.png");
    s_smokePuff_003 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smokePuff_003.addImage("s_smokePuff_003.png");
    s_smokePuff_004 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smokePuff_004.addImage("s_smokePuff_004.png");
    s_smokePuff_005 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smokePuff_005.addImage("s_smokePuff_005.png");
    s_smokePuff_006 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smokePuff_006.addImage("s_smokePuff_006.png");
    s_smokePuff_007 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smokePuff_007.addImage("s_smokePuff_007.png");
    s_smokePuff_008 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smokePuff_008.addImage("s_smokePuff_008.png");
    s_smokePuff_009 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smokePuff_009.addImage("s_smokePuff_009.png");
    s_smokePuff_010 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smokePuff_010.addImage("s_smokePuff_010.png");
    s_smokePuff_011 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smokePuff_011.addImage("s_smokePuff_011.png");
    s_smoke_plume_001 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_001.addImage("s_smoke_plume_001.png");
    s_smoke_plume_002 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_002.addImage("s_smoke_plume_002.png");
    s_smoke_plume_003 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_003.addImage("s_smoke_plume_003.png");
    s_smoke_plume_004 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_004.addImage("s_smoke_plume_004.png");
    s_smoke_plume_005 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_005.addImage("s_smoke_plume_005.png");
    s_smoke_plume_006 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_006.addImage("s_smoke_plume_006.png");
    s_smoke_plume_007 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_007.addImage("s_smoke_plume_007.png");
    s_smoke_plume_008 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_008.addImage("s_smoke_plume_008.png");
    s_smoke_plume_009 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_009.addImage("s_smoke_plume_009.png");
    s_smoke_plume_010 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_010.addImage("s_smoke_plume_010.png");
    s_smoke_plume_011 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_011.addImage("s_smoke_plume_011.png");
    s_smoke_plume_012 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_012.addImage("s_smoke_plume_012.png");
    s_smoke_plume_013 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_013.addImage("s_smoke_plume_013.png");
    s_smoke_plume_014 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_014.addImage("s_smoke_plume_014.png");
    s_smoke_plume_015 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_015.addImage("s_smoke_plume_015.png");
    s_smoke_plume_016 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_smoke_plume_016.addImage("s_smoke_plume_016.png");
    s_static_1 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_static_1.addImage("s_static_1.png");
    s_static_2 = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_static_2.addImage("s_static_2.png");
    s_terence_body = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_terence_body.addImage("s_terence_body.png");
    s_terence_body_stroke = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_terence_body_stroke.addImage("s_terence_body_stroke.png");
    s_terence_brow = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_terence_brow.addImage("s_terence_brow.png");
    s_terence_default = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_terence_default.addImage("s_terence_default.png");
    s_terence_eye = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_terence_eye.addImage("s_terence_eye.png");
    s_terence_eyes_closed = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_terence_eyes_closed.addImage("s_terence_eyes_closed.png");
    s_terence_head_feathers = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_terence_head_feathers.addImage("s_terence_head_feathers.png");
    s_terence_pupil = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_terence_pupil.addImage("s_terence_pupil.png");
    s_terence_smile = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_terence_smile.addImage("s_terence_smile.png");
    s_terence_tail = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_terence_tail.addImage("s_terence_tail.png");
    s_terence_wrinkle = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_terence_wrinkle.addImage("s_terence_wrinkle.png");
    s_trumpet = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_trumpet.addImage("s_trumpet.png");
    s_ui_vignette2_small = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_ui_vignette2_small.addImage("s_ui_vignette2_small.png");
    s_vignette_scanlines = new tbImage(textures.endScreens, 1, undefined, { "x": 0, "y": 0 });
    s_vignette_scanlines.addImage("s_vignette_scanlines.png");
    s_tgf_console_close = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 2, "y": 2 });
    s_tgf_console_close.addImage("s_tgf_console_close.png");
    s_tgf_console_pause = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 2, "y": 2 });
    s_tgf_console_pause.addImage("s_tgf_console_pause.png");
    s_tgf_console_play = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 2, "y": 2 });
    s_tgf_console_play.addImage("s_tgf_console_play.png");
    s_tgf_console_position = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 2, "y": 2 });
    s_tgf_console_position.addImage("s_tgf_console_position.png");
    s_tgf_console_restart = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 2, "y": 2 });
    s_tgf_console_restart.addImage("s_tgf_console_restart.png");
    s_tgf_console_step = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 2, "y": 2 });
    s_tgf_console_step.addImage("s_tgf_console_step.png");
    s_tgf_icon_exit = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_exit.addImage("s_tgf_icon_exit.png");
    s_tgf_icon_music_off = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_music_off.addImage("s_tgf_icon_music_off.png");
    s_tgf_icon_music_on = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_music_on.addImage("s_tgf_icon_music_on.png");
    s_tgf_icon_options = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_options.addImage("s_tgf_icon_options.png");
    s_tgf_icon_pause = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_pause.addImage("s_tgf_icon_pause.png");
    s_tgf_icon_play = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_play.addImage("s_tgf_icon_play.png");
    s_tgf_icon_quit = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_quit.addImage("s_tgf_icon_quit.png");
    s_tgf_icon_retry = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_retry.addImage("s_tgf_icon_retry.png");
    s_tgf_icon_retry_large = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_retry_large.addImage("s_tgf_icon_retry_large.png");
    s_tgf_icon_sound_off = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_sound_off.addImage("s_tgf_icon_sound_off.png");
    s_tgf_icon_sound_on = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_sound_on.addImage("s_tgf_icon_sound_on.png");
    s_tgf_icon_undo = new tbImage(textures.FrameworkTexture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_undo.addImage("s_tgf_icon_undo.png");
    s_tgf_slider_back = new tbImage(textures.FrameworkTexture_blue_1, 2, undefined, { "x": 0, "y": 0 });
    s_tgf_slider_back.addImage("s_tgf_slider_back.png");
    s_tgf_slider_back.addImage("s_tgf_slider_back_1.png");
    s_tgf_button = new tbImage(textures.FrameworkTexture_blue_2, 2, undefined, { "x": 0, "y": 0 });
    s_tgf_button.addImage("s_tgf_button.png");
    s_tgf_button.addImage("s_tgf_button_1.png");
    s_tgf_flag_fr = new tbImage(textures.FrameworkTexture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_fr.addImage("s_tgf_flag_fr.png");
    s_tgf_icon_play_large = new tbImage(textures.FrameworkTexture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_play_large.addImage("s_tgf_icon_play_large.png");
    s_tgf_progressbar_fill = new tbImage(textures.FrameworkTexture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_progressbar_fill.addImage("s_tgf_progressbar_fill.png");
    s_tgf_throbber = new tbImage(textures.FrameworkTexture_blue_2, 12, undefined, { "x": 0, "y": 0 });
    s_tgf_throbber.addImage("s_tgf_throbber.png");
    s_tgf_throbber.addImage("s_tgf_throbber_1.png");
    s_tgf_throbber.addImage("s_tgf_throbber_2.png");
    s_tgf_throbber.addImage("s_tgf_throbber_3.png");
    s_tgf_throbber.addImage("s_tgf_throbber_4.png");
    s_tgf_throbber.addImage("s_tgf_throbber_5.png");
    s_tgf_throbber.addImage("s_tgf_throbber_6.png");
    s_tgf_throbber.addImage("s_tgf_throbber_7.png");
    s_tgf_throbber.addImage("s_tgf_throbber_8.png");
    s_tgf_throbber.addImage("s_tgf_throbber_9.png");
    s_tgf_throbber.addImage("s_tgf_throbber_10.png");
    s_tgf_throbber.addImage("s_tgf_throbber_11.png");
    s_ui_progress_round_background = new tbImage(textures.FrameworkTexture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_ui_progress_round_background.addImage("s_ui_progress_round_background.png");
    s_ui_progress_round_foreground = new tbImage(textures.FrameworkTexture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_ui_progress_round_foreground.addImage("s_ui_progress_round_foreground.png");
    s_ui_star_empty = new tbImage(textures.FrameworkTexture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_ui_star_empty.addImage("s_ui_star_empty.png");
    s_tgf_flag_ar = new tbImage(textures.FrameworkTexture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_ar.addImage("s_tgf_flag_ar.png");
    s_tgf_flag_br = new tbImage(textures.FrameworkTexture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_br.addImage("s_tgf_flag_br.png");
    s_tgf_icon_difficulty_easy = new tbImage(textures.FrameworkTexture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_difficulty_easy.addImage("s_tgf_icon_difficulty_easy.png");
    s_tgf_flag_unknown = new tbImage(textures.FrameworkTexture_red_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_unknown.addImage("s_tgf_flag_unknown.png");
    s_tgf_transparent = new tbImage(textures.FrameworkTexture_red_1, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_transparent.addImage("s_tgf_transparent.png");
    s_tgf_flag_de = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_de.addImage("s_tgf_flag_de.png");
    s_tgf_flag_es = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_es.addImage("s_tgf_flag_es.png");
    s_tgf_flag_gb = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_gb.addImage("s_tgf_flag_gb.png");
    s_tgf_flag_jp = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_jp.addImage("s_tgf_flag_jp.png");
    s_tgf_flag_kr = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_kr.addImage("s_tgf_flag_kr.png");
    s_tgf_flag_nl = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_nl.addImage("s_tgf_flag_nl.png");
    s_tgf_flag_ru = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_ru.addImage("s_tgf_flag_ru.png");
    s_tgf_flag_tr = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_tr.addImage("s_tgf_flag_tr.png");
    s_tgf_flag_us = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_flag_us.addImage("s_tgf_flag_us.png");
    s_tgf_frame = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_frame.addImage("s_tgf_frame.png");
    s_tgf_icon_difficulty_hard = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_difficulty_hard.addImage("s_tgf_icon_difficulty_hard.png");
    s_tgf_icon_difficulty_medium = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_icon_difficulty_medium.addImage("s_tgf_icon_difficulty_medium.png");
    s_tgf_notification_error = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_notification_error.addImage("s_tgf_notification_error.png");
    s_tgf_notification_message = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_notification_message.addImage("s_tgf_notification_message.png");
    s_tgf_notification_warning = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_notification_warning.addImage("s_tgf_notification_warning.png");
    s_tgf_progressbar_back = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_progressbar_back.addImage("s_tgf_progressbar_back.png");
    s_tgf_slider_slider = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_slider_slider.addImage("s_tgf_slider_slider.png");
    s_tgf_tutorial_close = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_tutorial_close.addImage("s_tgf_tutorial_close.png");
    s_tgf_tutorial_next = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_tutorial_next.addImage("s_tgf_tutorial_next.png");
    s_tgf_tutorial_previous = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tgf_tutorial_previous.addImage("s_tgf_tutorial_previous.png");
    s_ui_background = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_ui_background.addImage("s_ui_background.png");
    s_ui_star_filled = new tbImage(textures.FrameworkTexture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_ui_star_filled.addImage("s_ui_star_filled.png");
    s_replay_overlay = new tbImage(textures.StaticTexture_red_1, 1, undefined, { "x": 345, "y": 192 });
    s_replay_overlay.addImage("s_replay_overlay.png");
    s_bg = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_bg.addImage("s_bg.png");
    s_bg_placeholder = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_bg_placeholder.addImage("s_bg_placeholder.png");
    s_button_glow2 = new tbImage(textures.texture, 1, undefined, { "x": 51, "y": 48 });
    s_button_glow2.addImage("s_button_glow2.png");
    s_cartoonSmoke = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_cartoonSmoke.addImage("s_cartoonSmoke.png");
    s_confetti1_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_confetti1_particle.addImage("s_confetti1_particle.png");
    s_confetti2_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_confetti2_particle.addImage("s_confetti2_particle.png");
    s_confetti3_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_confetti3_particle.addImage("s_confetti3_particle.png");
    s_confetti4_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_confetti4_particle.addImage("s_confetti4_particle.png");
    s_dust = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_dust.addImage("s_dust.png");
    s_explosion = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_explosion.addImage("s_explosion.png");
    s_feather = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_feather.addImage("s_feather.png");
    s_gatcha_bg = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_gatcha_bg.addImage("s_gatcha_bg.png");
    s_ice1_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_ice1_particle.addImage("s_ice1_particle.png");
    s_ice2_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_ice2_particle.addImage("s_ice2_particle.png");
    s_ice3_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_ice3_particle.addImage("s_ice3_particle.png");
    s_pig = new tbImage(textures.texture, 1, undefined, { "x": 32, "y": 29 });
    s_pig.addImage("s_pig.png");
    s_pig_blue = new tbImage(textures.texture, 1, undefined, { "x": 32, "y": 29 });
    s_pig_blue.addImage("s_pig_blue.png");
    s_pig_red = new tbImage(textures.texture, 1, undefined, { "x": 32, "y": 29 });
    s_pig_red.addImage("s_pig_red.png");
    s_sparkle_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_sparkle_particle.addImage("s_sparkle_particle.png");
    s_stone1_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_stone1_particle.addImage("s_stone1_particle.png");
    s_stone2_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_stone2_particle.addImage("s_stone2_particle.png");
    s_stone3_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_stone3_particle.addImage("s_stone3_particle.png");
    s_wood1_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_wood1_particle.addImage("s_wood1_particle.png");
    s_wood2_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_wood2_particle.addImage("s_wood2_particle.png");
    s_wood3_particle = new tbImage(textures.texture, 1, undefined, { "x": 0, "y": 0 });
    s_wood3_particle.addImage("s_wood3_particle.png");
    coolgames_logo = new tbImage(textures.textureSplash_blue_2, 1, undefined, { "x": 226, "y": 157 });
    coolgames_logo.addImage("coolgames_logo.png");
    rovio_logo = new tbImage(textures.textureSplash_red_2, 1, undefined, { "x": 307, "y": 76 });
    rovio_logo.addImage("rovio_logo.png");
    yt_splash_1366x768_alternative_2 = new tbImage(textures.textureSplash_red_2, 1, undefined, { "x": 0, "y": 0 });
    yt_splash_1366x768_alternative_2.addImage("yt_splash_1366x768_alternative_2.png");
    s_bg_plain_blue = new tbImage(textures.textureUI, 1, undefined, { "x": 0, "y": 0 });
    s_bg_plain_blue.addImage("s_bg_plain_blue.png");
    s_bg_plain_red = new tbImage(textures.textureUI, 1, undefined, { "x": 0, "y": 0 });
    s_bg_plain_red.addImage("s_bg_plain_red.png");
    s_icon_leaderboard_spine = new tbImage(textures.textureUI, 1, undefined, { "x": 0, "y": 0 });
    s_icon_leaderboard_spine.addImage("s_icon_leaderboard_spine.png");
    s_player_beams = new tbImage(textures.textureUI, 1, undefined, { "x": 159, "y": 159 });
    s_player_beams.addImage("s_player_beams.png");
    s_ui_vignette = new tbImage(textures.textureUI, 1, undefined, { "x": 0, "y": 0 });
    s_ui_vignette.addImage("s_ui_vignette.png");
    s_bar_container_blue = new tbImage(textures.textureUI_blue_2, 2, undefined, { "x": 0, "y": 0 });
    s_bar_container_blue.addImage("s_bar_container_blue.png");
    s_bar_container_blue.addImage("s_bar_container_blue_1.png");
    s_bar_title_blue = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_bar_title_blue.addImage("s_bar_title_blue.png");
    s_beta_label_lobby = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_beta_label_lobby.addImage("s_beta_label_lobby.png");
    s_btn_blue = new tbImage(textures.textureUI_blue_2, 2, undefined, { "x": 0, "y": 0 });
    s_btn_blue.addImage("s_btn_blue.png");
    s_btn_blue.addImage("s_btn_blue_1.png");
    s_btn_round_blue = new tbImage(textures.textureUI_blue_2, 2, undefined, { "x": 51, "y": 53 });
    s_btn_round_blue.addImage("s_btn_round_blue.png");
    s_btn_round_blue.addImage("s_btn_round_blue_1.png");
    s_btn_round_media_medium = new tbImage(textures.textureUI_blue_2, 2, undefined, { "x": 36, "y": 38 });
    s_btn_round_media_medium.addImage("s_btn_round_media_medium.png");
    s_btn_round_media_medium.addImage("s_btn_round_media_medium_1.png");
    s_buttonpowerbg = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 58, "y": 58 });
    s_buttonpowerbg.addImage("s_buttonpowerbg.png");
    s_buttonpower_blue_light = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 45, "y": 45 });
    s_buttonpower_blue_light.addImage("s_buttonpower_blue_light.png");
    s_buttonpower_grey = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 45, "y": 45 });
    s_buttonpower_grey.addImage("s_buttonpower_grey.png");
    s_button_glow3 = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 50, "y": 48 });
    s_button_glow3.addImage("s_button_glow3.png");
    s_button_rectangle2_white = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 98, "y": 44 });
    s_button_rectangle2_white.addImage("s_button_rectangle2_white.png");
    s_button_rectangle_white = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 98, "y": 25 });
    s_button_rectangle_white.addImage("s_button_rectangle_white.png");
    s_card_blue = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 69, "y": 101 });
    s_card_blue.addImage("s_card_blue.png");
    s_daily_reward_blue_bg_terence = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 65, "y": 66 });
    s_daily_reward_blue_bg_terence.addImage("s_daily_reward_blue_bg_terence.png");
    s_daily_reward_selection_box = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 110, "y": 146 });
    s_daily_reward_selection_box.addImage("s_daily_reward_selection_box.png");
    s_icon_back_small = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 12, "y": 18 });
    s_icon_back_small.addImage("s_icon_back_small.png");
    s_icon_plus_small = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 14, "y": 14 });
    s_icon_plus_small.addImage("s_icon_plus_small.png");
    s_icon_settings = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 34, "y": 37 });
    s_icon_settings.addImage("s_icon_settings.png");
    s_icon_share = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 36, "y": 25 });
    s_icon_share.addImage("s_icon_share.png");
    s_portrait_empty = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 80, "y": 80 });
    s_portrait_empty.addImage("s_portrait_empty.png");
    s_powerup_freeze = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 43, "y": 43 });
    s_powerup_freeze.addImage("s_powerup_freeze.png");
    s_powerup_stone_nator = new tbImage(textures.textureUI_blue_2, 1, undefined, { "x": 43, "y": 43 });
    s_powerup_stone_nator.addImage("s_powerup_stone_nator.png");
    s_expbar_empty = new tbImage(textures.textureUI_green_1, 1, undefined, { "x": 97, "y": 24 });
    s_expbar_empty.addImage("s_expbar_empty.png");
    s_badgebg = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 55, "y": 49 });
    s_badgebg.addImage("s_badgebg.png");
    s_bar_container_green = new tbImage(textures.textureUI_green_2, 2, undefined, { "x": 0, "y": 0 });
    s_bar_container_green.addImage("s_bar_container_green.png");
    s_bar_container_green.addImage("s_bar_container_green_1.png");
    s_bar_title_green = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_bar_title_green.addImage("s_bar_title_green.png");
    s_btn_green = new tbImage(textures.textureUI_green_2, 2, undefined, { "x": 0, "y": 0 });
    s_btn_green.addImage("s_btn_green.png");
    s_btn_green.addImage("s_btn_green_1.png");
    s_btn_round_green_big = new tbImage(textures.textureUI_green_2, 2, undefined, { "x": 72, "y": 75 });
    s_btn_round_green_big.addImage("s_btn_round_green_big.png");
    s_btn_round_green_big.addImage("s_btn_round_green_big_1.png");
    s_btn_round_green_small = new tbImage(textures.textureUI_green_2, 2, undefined, { "x": 35, "y": 38 });
    s_btn_round_green_small.addImage("s_btn_round_green_small.png");
    s_btn_round_green_small.addImage("s_btn_round_green_small_1.png");
    s_buttonpower_green = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 45, "y": 45 });
    s_buttonpower_green.addImage("s_buttonpower_green.png");
    s_buttonpower_teal = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 45, "y": 45 });
    s_buttonpower_teal.addImage("s_buttonpower_teal.png");
    s_card_bomb = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 69, "y": 101 });
    s_card_bomb.addImage("s_card_bomb.png");
    s_howtoplay_1 = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 342, "y": 192 });
    s_howtoplay_1.addImage("s_howtoplay_1.png");
    s_howtoplay_2 = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 342, "y": 192 });
    s_howtoplay_2.addImage("s_howtoplay_2.png");
    s_howtoplay_4 = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 342, "y": 192 });
    s_howtoplay_4.addImage("s_howtoplay_4.png");
    s_howtoplay_5 = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 342, "y": 192 });
    s_howtoplay_5.addImage("s_howtoplay_5.png");
    s_pigscore_main = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 34, "y": 34 });
    s_pigscore_main.addImage("s_pigscore_main.png");
    s_powerup_pig_swap = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 40, "y": 37 });
    s_powerup_pig_swap.addImage("s_powerup_pig_swap.png");
    s_progress_bar_fill = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_progress_bar_fill.addImage("s_progress_bar_fill.png");
    s_startRandom = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 233, "y": 0 });
    s_startRandom.addImage("s_startRandom.png");
    s_ui_pig_green_default_main = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 56, "y": 60 });
    s_ui_pig_green_default_main.addImage("s_ui_pig_green_default_main.png");
    s_ui_pig_green_scared_main = new tbImage(textures.textureUI_green_2, 1, undefined, { "x": 56, "y": 60 });
    s_ui_pig_green_scared_main.addImage("s_ui_pig_green_scared_main.png");
    s_bar_timebg = new tbImage(textures.textureUI_red_1, 1, undefined, { "x": 0, "y": 0 });
    s_bar_timebg.addImage("s_bar_timebg.png");
    s_bar_title_grey = new tbImage(textures.textureUI_red_1, 1, undefined, { "x": 0, "y": 0 });
    s_bar_title_grey.addImage("s_bar_title_grey.png");
    s_icon_close = new tbImage(textures.textureUI_red_1, 1, undefined, { "x": 18, "y": 18 });
    s_icon_close.addImage("s_icon_close.png");
    s_icon_list = new tbImage(textures.textureUI_red_1, 1, undefined, { "x": 40, "y": 32 });
    s_icon_list.addImage("s_icon_list.png");
    s_icon_play_small = new tbImage(textures.textureUI_red_1, 1, undefined, { "x": 20, "y": 20 });
    s_icon_play_small.addImage("s_icon_play_small.png");
    s_ui_pig_green_default = new tbImage(textures.textureUI_red_1, 1, undefined, { "x": 56, "y": 60 });
    s_ui_pig_green_default.addImage("s_ui_pig_green_default.png");
    s_ui_pig_green_scared = new tbImage(textures.textureUI_red_1, 1, undefined, { "x": 56, "y": 60 });
    s_ui_pig_green_scared.addImage("s_ui_pig_green_scared.png");
    s_bar_container_grey = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_bar_container_grey.addImage("s_bar_container_grey.png");
    s_bar_container_yellow = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_bar_container_yellow.addImage("s_bar_container_yellow.png");
    s_bar_title_yellow = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_bar_title_yellow.addImage("s_bar_title_yellow.png");
    s_bird_terrence = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 52, "y": 52 });
    s_bird_terrence.addImage("s_bird_terrence.png");
    s_btn_red = new tbImage(textures.textureUI_red_2, 2, undefined, { "x": 0, "y": 0 });
    s_btn_red.addImage("s_btn_red.png");
    s_btn_red.addImage("s_btn_red_1.png");
    s_btn_red_medium = new tbImage(textures.textureUI_red_2, 2, undefined, { "x": 0, "y": 0 });
    s_btn_red_medium.addImage("s_btn_red_medium.png");
    s_btn_red_medium.addImage("s_btn_red_medium_1.png");
    s_btn_red_small = new tbImage(textures.textureUI_red_2, 2, undefined, { "x": 0, "y": 0 });
    s_btn_red_small.addImage("s_btn_red_small.png");
    s_btn_red_small.addImage("s_btn_red_small_1.png");
    s_btn_round_gold = new tbImage(textures.textureUI_red_2, 2, undefined, { "x": 72, "y": 78 });
    s_btn_round_gold.addImage("s_btn_round_gold.png");
    s_btn_round_gold.addImage("s_btn_round_gold_1.png");
    s_btn_round_grey_big = new tbImage(textures.textureUI_red_2, 2, undefined, { "x": 72, "y": 75 });
    s_btn_round_grey_big.addImage("s_btn_round_grey_big.png");
    s_btn_round_grey_big.addImage("s_btn_round_grey_big_1.png");
    s_btn_round_orange_big = new tbImage(textures.textureUI_red_2, 2, undefined, { "x": 72, "y": 75 });
    s_btn_round_orange_big.addImage("s_btn_round_orange_big.png");
    s_btn_round_orange_big.addImage("s_btn_round_orange_big_1.png");
    s_btn_round_orange_small = new tbImage(textures.textureUI_red_2, 2, undefined, { "x": 35, "y": 38 });
    s_btn_round_orange_small.addImage("s_btn_round_orange_small.png");
    s_btn_round_orange_small.addImage("s_btn_round_orange_small_1.png");
    s_buttonpower_effect = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 72, "y": 72 });
    s_buttonpower_effect.addImage("s_buttonpower_effect.png");
    s_buttonpower_glow = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 78, "y": 78 });
    s_buttonpower_glow.addImage("s_buttonpower_glow.png");
    s_buttonpower_red = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 45, "y": 45 });
    s_buttonpower_red.addImage("s_buttonpower_red.png");
    s_button_beam = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 86, "y": 86 });
    s_button_beam.addImage("s_button_beam.png");
    s_button_small = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 23, "y": 23 });
    s_button_small.addImage("s_button_small.png");
    s_card_mathilda = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 140, "y": 203 });
    s_card_mathilda.addImage("s_card_mathilda.png");
    s_card_red = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 69, "y": 101 });
    s_card_red.addImage("s_card_red.png");
    s_card_yellow = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 69, "y": 101 });
    s_card_yellow.addImage("s_card_yellow.png");
    s_daily_reward_panel = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 543, "y": 376 });
    s_daily_reward_panel.addImage("s_daily_reward_panel.png");
    s_daily_reward_paper_sheet = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 81, "y": 126 });
    s_daily_reward_paper_sheet.addImage("s_daily_reward_paper_sheet.png");
    s_daily_reward_paper_sheet_torn = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 77, "y": 126 });
    s_daily_reward_paper_sheet_torn.addImage("s_daily_reward_paper_sheet_torn.png");
    s_daily_reward_powerup_icon = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 51, "y": 51 });
    s_daily_reward_powerup_icon.addImage("s_daily_reward_powerup_icon.png");
    s_friend_invite_matilda = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 125, "y": 147 });
    s_friend_invite_matilda.addImage("s_friend_invite_matilda.png");
    s_gemcontainer = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 94, "y": 35 });
    s_gemcontainer.addImage("s_gemcontainer.png");
    s_howtoplay_3 = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 342, "y": 192 });
    s_howtoplay_3.addImage("s_howtoplay_3.png");
    s_icon_back = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_icon_back.addImage("s_icon_back.png");
    s_icon_fforward_small = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_icon_fforward_small.addImage("s_icon_fforward_small.png");
    s_icon_forward_small = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 12, "y": 18 });
    s_icon_forward_small.addImage("s_icon_forward_small.png");
    s_icon_gem = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 64, "y": 64 });
    s_icon_gem.addImage("s_icon_gem.png");
    s_icon_leaderboard = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_icon_leaderboard.addImage("s_icon_leaderboard.png");
    s_icon_movie = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 61, "y": 50 });
    s_icon_movie.addImage("s_icon_movie.png");
    s_icon_music = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 28, "y": 30 });
    s_icon_music.addImage("s_icon_music.png");
    s_icon_musicoff = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 28, "y": 30 });
    s_icon_musicoff.addImage("s_icon_musicoff.png");
    s_icon_play = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 37, "y": 38 });
    s_icon_play.addImage("s_icon_play.png");
    s_icon_plus = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 40, "y": 41 });
    s_icon_plus.addImage("s_icon_plus.png");
    s_icon_poke = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 18, "y": 15 });
    s_icon_poke.addImage("s_icon_poke.png");
    s_icon_powerup = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 22, "y": 35 });
    s_icon_powerup.addImage("s_icon_powerup.png");
    s_icon_sound = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 28, "y": 25 });
    s_icon_sound.addImage("s_icon_sound.png");
    s_icon_soundoff = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 28, "y": 25 });
    s_icon_soundoff.addImage("s_icon_soundoff.png");
    s_pigscore = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 34, "y": 34 });
    s_pigscore.addImage("s_pigscore.png");
    s_popup_add_homescreen_content = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 200, "y": 141 });
    s_popup_add_homescreen_content.addImage("s_popup_add_homescreen_content.png");
    s_popup_bottom = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 461, "y": 47 });
    s_popup_bottom.addImage("s_popup_bottom.png");
    s_popup_close = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 44, "y": 24 });
    s_popup_close.addImage("s_popup_close.png");
    s_popup_top = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 441, "y": 52 });
    s_popup_top.addImage("s_popup_top.png");
    s_portrait_fill = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 80, "y": 80 });
    s_portrait_fill.addImage("s_portrait_fill.png");
    s_powerup_shield = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 38, "y": 38 });
    s_powerup_shield.addImage("s_powerup_shield.png");
    s_powerup_tnt = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 43, "y": 43 });
    s_powerup_tnt.addImage("s_powerup_tnt.png");
    s_profile_placeholder = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 80, "y": 80 });
    s_profile_placeholder.addImage("s_profile_placeholder.png");
    s_rankbg = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 24, "y": 24 });
    s_rankbg.addImage("s_rankbg.png");
    s_rectangle_white = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 64, "y": 64 });
    s_rectangle_white.addImage("s_rectangle_white.png");
    s_startFriend = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 136, "y": 0 });
    s_startFriend.addImage("s_startFriend.png");
    s_terence_timer_lobby = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_terence_timer_lobby.addImage("s_terence_timer_lobby.png");
    s_titlesign = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 425, "y": 52 });
    s_titlesign.addImage("s_titlesign.png");
    s_trophy = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_trophy.addImage("s_trophy.png");
    s_versus_center = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 56, "y": 54 });
    s_versus_center.addImage("s_versus_center.png");
    s_win_banner = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 474, "y": 145 });
    s_win_banner.addImage("s_win_banner.png");
    s_win_scorebg = new tbImage(textures.textureUI_red_2, 1, undefined, { "x": 239, "y": 64 });
    s_win_scorebg.addImage("s_win_scorebg.png");
    s_icon_toggle_music_off = new tbImage(textures.texture_blue_1, 1, undefined, { "x": 1, "y": 1 });
    s_icon_toggle_music_off.addImage("s_icon_toggle_music_off.png");
    s_icon_toggle_music_on = new tbImage(textures.texture_blue_1, 1, undefined, { "x": 1, "y": 1 });
    s_icon_toggle_music_on.addImage("s_icon_toggle_music_on.png");
    s_icon_toggle_sfx_off = new tbImage(textures.texture_blue_1, 1, undefined, { "x": 1, "y": 1 });
    s_icon_toggle_sfx_off.addImage("s_icon_toggle_sfx_off.png");
    s_icon_toggle_sfx_on = new tbImage(textures.texture_blue_1, 1, undefined, { "x": 1, "y": 1 });
    s_icon_toggle_sfx_on.addImage("s_icon_toggle_sfx_on.png");
    s_platform_stone = new tbImage(textures.texture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_platform_stone.addImage("s_platform_stone.png");
    s_stones = new tbImage(textures.texture_blue_1, 1, undefined, { "x": 0, "y": 0 });
    s_stones.addImage("s_stones.png");
    s_about = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_about.addImage("s_about.png");
    s_bg_blurred_20 = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_bg_blurred_20.addImage("s_bg_blurred_20.png");
    s_blueside = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 323, "y": 165 });
    s_blueside.addImage("s_blueside.png");
    s_btn_arrow_blue = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 0, "y": 0 });
    s_btn_arrow_blue.addImage("s_btn_arrow_blue.png");
    s_btn_arrow_blue.addImage("s_btn_arrow_blue_1.png");
    s_btn_arrow_media = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 0, "y": 0 });
    s_btn_arrow_media.addImage("s_btn_arrow_media.png");
    s_btn_arrow_media.addImage("s_btn_arrow_media_1.png");
    s_btn_bigtext = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 1, "y": 2 });
    s_btn_bigtext.addImage("s_btn_bigtext.png");
    s_btn_bigtext.addImage("s_btn_bigtext_1.png");
    s_btn_big_restart = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 2, "y": 2 });
    s_btn_big_restart.addImage("s_btn_big_restart.png");
    s_btn_big_restart.addImage("s_btn_big_restart_1.png");
    s_btn_big_start = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 2, "y": 2 });
    s_btn_big_start.addImage("s_btn_big_start.png");
    s_btn_big_start.addImage("s_btn_big_start_1.png");
    s_btn_small_exit = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 2, "y": 2 });
    s_btn_small_exit.addImage("s_btn_small_exit.png");
    s_btn_small_exit.addImage("s_btn_small_exit_1.png");
    s_btn_small_options = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 2, "y": 2 });
    s_btn_small_options.addImage("s_btn_small_options.png");
    s_btn_small_options.addImage("s_btn_small_options_1.png");
    s_btn_small_pause = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 2, "y": 2 });
    s_btn_small_pause.addImage("s_btn_small_pause.png");
    s_btn_small_pause.addImage("s_btn_small_pause_1.png");
    s_btn_small_retry = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 2, "y": 2 });
    s_btn_small_retry.addImage("s_btn_small_retry.png");
    s_btn_small_retry.addImage("s_btn_small_retry_1.png");
    s_btn_small_undo = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 2, "y": 2 });
    s_btn_small_undo.addImage("s_btn_small_undo.png");
    s_btn_small_undo.addImage("s_btn_small_undo_1.png");
    s_btn_standard = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 0, "y": 0 });
    s_btn_standard.addImage("s_btn_standard.png");
    s_btn_standard.addImage("s_btn_standard_1.png");
    s_btn_toggle = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 2, "y": 2 });
    s_btn_toggle.addImage("s_btn_toggle.png");
    s_btn_toggle.addImage("s_btn_toggle_1.png");
    s_buttons_bigtext = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 0, "y": 2 });
    s_buttons_bigtext.addImage("s_buttons_bigtext.png");
    s_buttons_bigtext.addImage("s_buttons_bigtext_1.png");
    s_buttons_bigtext_play = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 2, "y": 2 });
    s_buttons_bigtext_play.addImage("s_buttons_bigtext_play.png");
    s_cloud = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_cloud.addImage("s_cloud.png");
    s_fog = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_fog.addImage("s_fog.png");
    s_fog_2 = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_fog_2.addImage("s_fog_2.png");
    s_icon_toggle_fxoff = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 1, "y": 2 });
    s_icon_toggle_fxoff.addImage("s_icon_toggle_fxoff.png");
    s_icon_toggle_fxoff.addImage("s_icon_toggle_fxoff_1.png");
    s_icon_toggle_fxon = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 1, "y": 2 });
    s_icon_toggle_fxon.addImage("s_icon_toggle_fxon.png");
    s_icon_toggle_fxon.addImage("s_icon_toggle_fxon_1.png");
    s_icon_toggle_musicoff = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 1, "y": 2 });
    s_icon_toggle_musicoff.addImage("s_icon_toggle_musicoff.png");
    s_icon_toggle_musicoff.addImage("s_icon_toggle_musicoff_1.png");
    s_icon_toggle_musicon = new tbImage(textures.texture_blue_2, 2, undefined, { "x": 0, "y": 0 });
    s_icon_toggle_musicon.addImage("s_icon_toggle_musicon.png");
    s_icon_toggle_musicon.addImage("s_icon_toggle_musicon_1.png");
    s_level2_0 = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_level2_0.addImage("s_level2_0.png");
    s_level2_lock = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_level2_lock.addImage("s_level2_lock.png");
    s_logo = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_logo.addImage("s_logo.png");
    s_logo_tinglygames = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_logo_tinglygames.addImage("s_logo_tinglygames.png");
    s_overlay_assignment = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_overlay_assignment.addImage("s_overlay_assignment.png");
    s_platform_stone_end_l = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_platform_stone_end_l.addImage("s_platform_stone_end_l.png");
    s_platform_stone_end_r = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_platform_stone_end_r.addImage("s_platform_stone_end_r.png");
    s_popup_darkblue_rect = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_popup_darkblue_rect.addImage("s_popup_darkblue_rect.png");
    s_scorebar_blue = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 134, "y": 25 });
    s_scorebar_blue.addImage("s_scorebar_blue.png");
    s_swapPig_selected = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 48, "y": 48 });
    s_swapPig_selected.addImage("s_swapPig_selected.png");
    s_ui_landscape = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_ui_landscape.addImage("s_ui_landscape.png");
    s_ui_portrait = new tbImage(textures.texture_blue_2, 1, undefined, { "x": 0, "y": 0 });
    s_ui_portrait.addImage("s_ui_portrait.png");
    f_01 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_01.addImage("f_01.png");
    f_02 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_02.addImage("f_02.png");
    f_03 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_03.addImage("f_03.png");
    f_04 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_04.addImage("f_04.png");
    f_05 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_05.addImage("f_05.png");
    f_06 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_06.addImage("f_06.png");
    f_07 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_07.addImage("f_07.png");
    f_08 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_08.addImage("f_08.png");
    f_09 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_09.addImage("f_09.png");
    f_10 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_10.addImage("f_10.png");
    f_11 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_11.addImage("f_11.png");
    f_12 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_12.addImage("f_12.png");
    f_13 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_13.addImage("f_13.png");
    f_14 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_14.addImage("f_14.png");
    f_15 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_15.addImage("f_15.png");
    f_16 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_16.addImage("f_16.png");
    f_17 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_17.addImage("f_17.png");
    f_18 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_18.addImage("f_18.png");
    f_19 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_19.addImage("f_19.png");
    f_20 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_20.addImage("f_20.png");
    f_21 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_21.addImage("f_21.png");
    f_22 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_22.addImage("f_22.png");
    f_23 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_23.addImage("f_23.png");
    f_24 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_24.addImage("f_24.png");
    f_25 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    f_25.addImage("f_25.png");
    m_01 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_01.addImage("m_01.png");
    m_02 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_02.addImage("m_02.png");
    m_03 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_03.addImage("m_03.png");
    m_04 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_04.addImage("m_04.png");
    m_05 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_05.addImage("m_05.png");
    m_06 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_06.addImage("m_06.png");
    m_07 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_07.addImage("m_07.png");
    m_08 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_08.addImage("m_08.png");
    m_09 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_09.addImage("m_09.png");
    m_10 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_10.addImage("m_10.png");
    m_11 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_11.addImage("m_11.png");
    m_12 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_12.addImage("m_12.png");
    m_13 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_13.addImage("m_13.png");
    m_14 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_14.addImage("m_14.png");
    m_15 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_15.addImage("m_15.png");
    m_16 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_16.addImage("m_16.png");
    m_17 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_17.addImage("m_17.png");
    m_18 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_18.addImage("m_18.png");
    m_19 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_19.addImage("m_19.png");
    m_20 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_20.addImage("m_20.png");
    m_21 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_21.addImage("m_21.png");
    m_22 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_22.addImage("m_22.png");
    m_23 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_23.addImage("m_23.png");
    m_24 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_24.addImage("m_24.png");
    m_25 = new tbImage(textures.texture_fake_players, 1, undefined, { "x": 40, "y": 40 });
    m_25.addImage("m_25.png");
    s_mighty_scope_bottom = new tbImage(textures.texture_green_1, 1, undefined, { "x": 70, "y": 100 });
    s_mighty_scope_bottom.addImage("s_mighty_scope_bottom.png");
    s_bg_tower = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_bg_tower.addImage("s_bg_tower.png");
    s_bg_tower_2 = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_bg_tower_2.addImage("s_bg_tower_2.png");
    s_big_platform = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_big_platform.addImage("s_big_platform.png");
    s_btn_arrow_green = new tbImage(textures.texture_green_2, 2, undefined, { "x": 0, "y": 0 });
    s_btn_arrow_green.addImage("s_btn_arrow_green.png");
    s_btn_arrow_green.addImage("s_btn_arrow_green_1.png");
    s_btn_round_video = new tbImage(textures.texture_green_2, 2, undefined, { "x": 46, "y": 52 });
    s_btn_round_video.addImage("s_btn_round_video.png");
    s_btn_round_video.addImage("s_btn_round_video_1.png");
    s_buttonbg_mighty_scope_active = new tbImage(textures.texture_green_2, 1, undefined, { "x": 45, "y": 45 });
    s_buttonbg_mighty_scope_active.addImage("s_buttonbg_mighty_scope_active.png");
    s_floating_platform = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_floating_platform.addImage("s_floating_platform.png");
    s_floating_platform2 = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_floating_platform2.addImage("s_floating_platform2.png");
    s_floating_platform3 = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_floating_platform3.addImage("s_floating_platform3.png");
    s_floating_stackable_platform = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_floating_stackable_platform.addImage("s_floating_stackable_platform.png");
    s_grey_floating_stackable_platform = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_grey_floating_stackable_platform.addImage("s_grey_floating_stackable_platform.png");
    s_overlay_options = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_overlay_options.addImage("s_overlay_options.png");
    s_overlay_settings = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_overlay_settings.addImage("s_overlay_settings.png");
    s_progressbar_fill_green = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_progressbar_fill_green.addImage("s_progressbar_fill_green.png");
    s_rank_emblem_azure = new tbImage(textures.texture_green_2, 1, undefined, { "x": 65, "y": 65 });
    s_rank_emblem_azure.addImage("s_rank_emblem_azure.png");
    s_rank_emblem_diamond = new tbImage(textures.texture_green_2, 1, undefined, { "x": 65, "y": 65 });
    s_rank_emblem_diamond.addImage("s_rank_emblem_diamond.png");
    s_rank_emblem_elder_silver = new tbImage(textures.texture_green_2, 1, undefined, { "x": 73, "y": 68 });
    s_rank_emblem_elder_silver.addImage("s_rank_emblem_elder_silver.png");
    s_rank_emblem_emerald = new tbImage(textures.texture_green_2, 1, undefined, { "x": 65, "y": 65 });
    s_rank_emblem_emerald.addImage("s_rank_emblem_emerald.png");
    s_rank_emblem_silver = new tbImage(textures.texture_green_2, 1, undefined, { "x": 65, "y": 65 });
    s_rank_emblem_silver.addImage("s_rank_emblem_silver.png");
    s_slingshot_back_azure = new tbImage(textures.texture_green_2, 1, undefined, { "x": 17, "y": 21 });
    s_slingshot_back_azure.addImage("s_slingshot_back_azure.png");
    s_slingshot_back_diamond = new tbImage(textures.texture_green_2, 1, undefined, { "x": 17, "y": 21 });
    s_slingshot_back_diamond.addImage("s_slingshot_back_diamond.png");
    s_slingshot_back_elder_silver = new tbImage(textures.texture_green_2, 1, undefined, { "x": 17, "y": 21 });
    s_slingshot_back_elder_silver.addImage("s_slingshot_back_elder_silver.png");
    s_slingshot_back_emerald = new tbImage(textures.texture_green_2, 1, undefined, { "x": 17, "y": 21 });
    s_slingshot_back_emerald.addImage("s_slingshot_back_emerald.png");
    s_slingshot_back_silver = new tbImage(textures.texture_green_2, 1, undefined, { "x": 17, "y": 21 });
    s_slingshot_back_silver.addImage("s_slingshot_back_silver.png");
    s_slingshot_front_azure = new tbImage(textures.texture_green_2, 1, undefined, { "x": 44, "y": 23 });
    s_slingshot_front_azure.addImage("s_slingshot_front_azure.png");
    s_slingshot_front_diamond = new tbImage(textures.texture_green_2, 1, undefined, { "x": 44, "y": 23 });
    s_slingshot_front_diamond.addImage("s_slingshot_front_diamond.png");
    s_slingshot_front_elder_silver = new tbImage(textures.texture_green_2, 1, undefined, { "x": 44, "y": 23 });
    s_slingshot_front_elder_silver.addImage("s_slingshot_front_elder_silver.png");
    s_slingshot_front_emerald = new tbImage(textures.texture_green_2, 1, undefined, { "x": 44, "y": 23 });
    s_slingshot_front_emerald.addImage("s_slingshot_front_emerald.png");
    s_slingshot_front_silver = new tbImage(textures.texture_green_2, 1, undefined, { "x": 44, "y": 23 });
    s_slingshot_front_silver.addImage("s_slingshot_front_silver.png");
    s_small_platform = new tbImage(textures.texture_green_2, 1, undefined, { "x": 0, "y": 0 });
    s_small_platform.addImage("s_small_platform.png");
    s_tgf_buttonSelect = new tbImage(textures.texture_green_2, 2, undefined, { "x": 0, "y": 0 });
    s_tgf_buttonSelect.addImage("s_tgf_buttonSelect.png");
    s_tgf_buttonSelect.addImage("s_tgf_buttonSelect_1.png");
    blackAdFrame = new tbImage(textures.texture_red_1, 1, undefined, { "x": 0, "y": 0 });
    blackAdFrame.addImage("blackAdFrame.png");
    s_black_square = new tbImage(textures.texture_red_1, 1, undefined, { "x": 8, "y": 8 });
    s_black_square.addImage("s_black_square.png");
    s_fg_object = new tbImage(textures.texture_red_1, 1, undefined, { "x": 0, "y": 0 });
    s_fg_object.addImage("s_fg_object.png");
    s_fg_object_2 = new tbImage(textures.texture_red_1, 1, undefined, { "x": 0, "y": 0 });
    s_fg_object_2.addImage("s_fg_object_2.png");
    s_leaves = new tbImage(textures.texture_red_1, 1, undefined, { "x": 0, "y": 0 });
    s_leaves.addImage("s_leaves.png");
    s_leaves_2 = new tbImage(textures.texture_red_1, 1, undefined, { "x": 0, "y": 0 });
    s_leaves_2.addImage("s_leaves_2.png");
    s_slingshot_bascket = new tbImage(textures.texture_red_1, 1, undefined, { "x": 28, "y": 16 });
    s_slingshot_bascket.addImage("s_slingshot_bascket.png");
    s_static_ground = new tbImage(textures.texture_red_1, 1, undefined, { "x": 32, "y": 32 });
    s_static_ground.addImage("s_static_ground.png");
    transparent_4x4 = new tbImage(textures.texture_red_1, 1, undefined, { "x": 0, "y": 0 });
    transparent_4x4.addImage("transparent_4x4.png");
    custom_update_06 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    custom_update_06.addImage("custom_update_06.png");
    FB_MessengerMock = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    FB_MessengerMock.addImage("FB_MessengerMock.png");
    s_background = new tbImage(textures.texture_red_2, 4, undefined, { "x": 0, "y": 0 });
    s_background.addImage("s_background.png");
    s_background.addImage("s_background_1.png");
    s_background.addImage("s_background_2.png");
    s_background.addImage("s_background_3.png");
    s_btn_orange = new tbImage(textures.texture_red_2, 2, undefined, { "x": 0, "y": 0 });
    s_btn_orange.addImage("s_btn_orange.png");
    s_btn_orange.addImage("s_btn_orange_1.png");
    s_buttonbg_mighty_scope = new tbImage(textures.texture_red_2, 2, undefined, { "x": 0, "y": 0 });
    s_buttonbg_mighty_scope.addImage("s_buttonbg_mighty_scope.png");
    s_buttonbg_mighty_scope.addImage("s_buttonbg_mighty_scope_1.png");
    s_buttonpower_disabled = new tbImage(textures.texture_red_2, 1, undefined, { "x": 46, "y": 52 });
    s_buttonpower_disabled.addImage("s_buttonpower_disabled.png");
    s_button_drop_icon_coin = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_button_drop_icon_coin.addImage("s_button_drop_icon_coin.png");
    s_card_big = new tbImage(textures.texture_red_2, 1, undefined, { "x": 140, "y": 203 });
    s_card_big.addImage("s_card_big.png");
    s_indicator_noplace = new tbImage(textures.texture_red_2, 1, undefined, { "x": 35, "y": 35 });
    s_indicator_noplace.addImage("s_indicator_noplace.png");
    s_indicator_target = new tbImage(textures.texture_red_2, 1, undefined, { "x": 50, "y": 50 });
    s_indicator_target.addImage("s_indicator_target.png");
    s_level2_1 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_level2_1.addImage("s_level2_1.png");
    s_level2_2 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_level2_2.addImage("s_level2_2.png");
    s_level2_3 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_level2_3.addImage("s_level2_3.png");
    s_mighty_scope_popup_image = new tbImage(textures.texture_red_2, 1, undefined, { "x": 127, "y": 127 });
    s_mighty_scope_popup_image.addImage("s_mighty_scope_popup_image.png");
    s_mighty_scope_sparkle = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_mighty_scope_sparkle.addImage("s_mighty_scope_sparkle.png");
    s_mighty_scope_top = new tbImage(textures.texture_red_2, 1, undefined, { "x": 83, "y": 55 });
    s_mighty_scope_top.addImage("s_mighty_scope_top.png");
    s_overlay_worldmap_levelselect = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_overlay_worldmap_levelselect.addImage("s_overlay_worldmap_levelselect.png");
    s_portrait_01 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 80, "y": 80 });
    s_portrait_01.addImage("s_portrait_01.png");
    s_portrait_02 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 80, "y": 80 });
    s_portrait_02.addImage("s_portrait_02.png");
    s_portrait_03 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 80, "y": 80 });
    s_portrait_03.addImage("s_portrait_03.png");
    s_portrait_04 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 80, "y": 80 });
    s_portrait_04.addImage("s_portrait_04.png");
    s_portrait_05 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 80, "y": 80 });
    s_portrait_05.addImage("s_portrait_05.png");
    s_portrait_06 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 80, "y": 80 });
    s_portrait_06.addImage("s_portrait_06.png");
    s_portrait_07 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 80, "y": 80 });
    s_portrait_07.addImage("s_portrait_07.png");
    s_powerupcount = new tbImage(textures.texture_red_2, 1, undefined, { "x": 24, "y": 24 });
    s_powerupcount.addImage("s_powerupcount.png");
    s_practice_match_floater = new tbImage(textures.texture_red_2, 1, undefined, { "x": 260, "y": 52 });
    s_practice_match_floater.addImage("s_practice_match_floater.png");
    s_profilepicture_default = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_profilepicture_default.addImage("s_profilepicture_default.png");
    s_progressbar_bg = new tbImage(textures.texture_red_2, 1, undefined, { "x": 298, "y": 50 });
    s_progressbar_bg.addImage("s_progressbar_bg.png");
    s_progressbar_fill_white = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_progressbar_fill_white.addImage("s_progressbar_fill_white.png");
    s_rank_emblem_amethyst = new tbImage(textures.texture_red_2, 1, undefined, { "x": 65, "y": 65 });
    s_rank_emblem_amethyst.addImage("s_rank_emblem_amethyst.png");
    s_rank_emblem_bronze = new tbImage(textures.texture_red_2, 1, undefined, { "x": 65, "y": 65 });
    s_rank_emblem_bronze.addImage("s_rank_emblem_bronze.png");
    s_rank_emblem_elder_gold = new tbImage(textures.texture_red_2, 1, undefined, { "x": 73, "y": 69 });
    s_rank_emblem_elder_gold.addImage("s_rank_emblem_elder_gold.png");
    s_rank_emblem_gold = new tbImage(textures.texture_red_2, 1, undefined, { "x": 65, "y": 65 });
    s_rank_emblem_gold.addImage("s_rank_emblem_gold.png");
    s_rank_emblem_wood = new tbImage(textures.texture_red_2, 1, undefined, { "x": 65, "y": 65 });
    s_rank_emblem_wood.addImage("s_rank_emblem_wood.png");
    s_redcross = new tbImage(textures.texture_red_2, 1, undefined, { "x": 37, "y": 38 });
    s_redcross.addImage("s_redcross.png");
    s_redside = new tbImage(textures.texture_red_2, 1, undefined, { "x": 323, "y": 165 });
    s_redside.addImage("s_redside.png");
    s_scorebar_pink = new tbImage(textures.texture_red_2, 1, undefined, { "x": 134, "y": 25 });
    s_scorebar_pink.addImage("s_scorebar_pink.png");
    s_screen_start = new tbImage(textures.texture_red_2, 4, undefined, { "x": 0, "y": 0 });
    s_screen_start.addImage("s_screen_start.png");
    s_screen_start.addImage("s_screen_start_1.png");
    s_screen_start.addImage("s_screen_start_2.png");
    s_screen_start.addImage("s_screen_start_3.png");
    s_sfx_star = new tbImage(textures.texture_red_2, 8, undefined, { "x": 0, "y": 0 });
    s_sfx_star.addImage("s_sfx_star.png");
    s_sfx_star.addImage("s_sfx_star_1.png");
    s_sfx_star.addImage("s_sfx_star_2.png");
    s_sfx_star.addImage("s_sfx_star_3.png");
    s_sfx_star.addImage("s_sfx_star_4.png");
    s_sfx_star.addImage("s_sfx_star_5.png");
    s_sfx_star.addImage("s_sfx_star_6.png");
    s_sfx_star.addImage("s_sfx_star_7.png");
    s_shield = new tbImage(textures.texture_red_2, 1, undefined, { "x": 60, "y": 65 });
    s_shield.addImage("s_shield.png");
    s_shield01 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 48, "y": 48 });
    s_shield01.addImage("s_shield01.png");
    s_slingshot_back = new tbImage(textures.texture_red_2, 1, undefined, { "x": 17, "y": 21 });
    s_slingshot_back.addImage("s_slingshot_back.png");
    s_slingshot_back_amethyst = new tbImage(textures.texture_red_2, 1, undefined, { "x": 17, "y": 21 });
    s_slingshot_back_amethyst.addImage("s_slingshot_back_amethyst.png");
    s_slingshot_back_bronze = new tbImage(textures.texture_red_2, 1, undefined, { "x": 17, "y": 21 });
    s_slingshot_back_bronze.addImage("s_slingshot_back_bronze.png");
    s_slingshot_back_elder_gold = new tbImage(textures.texture_red_2, 1, undefined, { "x": 17, "y": 21 });
    s_slingshot_back_elder_gold.addImage("s_slingshot_back_elder_gold.png");
    s_slingshot_back_gold = new tbImage(textures.texture_red_2, 1, undefined, { "x": 17, "y": 21 });
    s_slingshot_back_gold.addImage("s_slingshot_back_gold.png");
    s_slingshot_front = new tbImage(textures.texture_red_2, 1, undefined, { "x": 44, "y": 23 });
    s_slingshot_front.addImage("s_slingshot_front.png");
    s_slingshot_front_amethyst = new tbImage(textures.texture_red_2, 1, undefined, { "x": 44, "y": 23 });
    s_slingshot_front_amethyst.addImage("s_slingshot_front_amethyst.png");
    s_slingshot_front_bronze = new tbImage(textures.texture_red_2, 1, undefined, { "x": 44, "y": 23 });
    s_slingshot_front_bronze.addImage("s_slingshot_front_bronze.png");
    s_slingshot_front_elder_gold = new tbImage(textures.texture_red_2, 1, undefined, { "x": 44, "y": 23 });
    s_slingshot_front_elder_gold.addImage("s_slingshot_front_elder_gold.png");
    s_slingshot_front_gold = new tbImage(textures.texture_red_2, 1, undefined, { "x": 44, "y": 23 });
    s_slingshot_front_gold.addImage("s_slingshot_front_gold.png");
    s_slingshot_rubber = new tbImage(textures.texture_red_2, 1, undefined, { "x": 4, "y": 9 });
    s_slingshot_rubber.addImage("s_slingshot_rubber.png");
    s_star01_empty = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_star01_empty.addImage("s_star01_empty.png");
    s_star01_fill = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_star01_fill.addImage("s_star01_fill.png");
    s_star02_empty = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_star02_empty.addImage("s_star02_empty.png");
    s_star02_fill = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_star02_fill.addImage("s_star02_fill.png");
    s_star03_empty = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_star03_empty.addImage("s_star03_empty.png");
    s_star03_fill = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_star03_fill.addImage("s_star03_fill.png");
    s_s_matilda_egg = new tbImage(textures.texture_red_2, 1, undefined, { "x": 23, "y": 24 });
    s_s_matilda_egg.addImage("s_s_matilda_egg.png");
    s_trail_splash = new tbImage(textures.texture_red_2, 1, undefined, { "x": 128, "y": 128 });
    s_trail_splash.addImage("s_trail_splash.png");
    s_tutorial = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tutorial.addImage("s_tutorial.png");
    s_tutorialButton_exit = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tutorialButton_exit.addImage("s_tutorialButton_exit.png");
    s_tutorialButton_next = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tutorialButton_next.addImage("s_tutorialButton_next.png");
    s_tutorialButton_previous = new tbImage(textures.texture_red_2, 1, undefined, { "x": 0, "y": 0 });
    s_tutorialButton_previous.addImage("s_tutorialButton_previous.png");
    s_win_board2 = new tbImage(textures.texture_red_2, 1, undefined, { "x": 228, "y": 39 });
    s_win_board2.addImage("s_win_board2.png");
};
